// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-24T16:59:15.033Z
// Property: Sonoran Reserve (ID: 6767906449166453)
// Collections: 27 amenities, 10 floorplans (live), 22 photos, 50 POIs, 5 reviews, 4 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166453",
  "property_external_id": "4ce6wgk",
  "property_zillow_url": "https://www.zillow.com/apartments/tucson-az/sonoran-reserve-apartments/5XnKRq/",
  "property_apartments_url": "https://www.apartments.com/sonoran-reserve-tucson-az/4ce6wgk/",
  "property_google_business_url": "https://www.google.com/maps/place/Sonoran+Reserve/data=!4m2!3m1!1s0x0:0xe881105638c5a3c1?sa=X&ved=2ahUKEwiutoPc5KeSAxX1QkEAHah2DlEQ_BJ6BAgTEAA&hl=en&gl=us",
  "property_linkedin_url": "https://www.linkedin.com/company/sonoran-land-resources-llc",
  "property_hubspot_id": "40241387851",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "232SRV",
  "property_status": null,
  "property_slug": "sonoran-reserve",
  "property_name": "Sonoran Reserve",
  "property_website_url": "http://www.sonoranreserveapts.com/",
  "property_domain": "https://www.sonoranreserveapts.com/",
  "property_address": "2800 West Broadway Boulevard",
  "property_full_address": "2800 W Broadway Blvd, Tucson, AZ 85745",
  "property_address_1": "2800 W Broadway Blvd",
  "property_address_2": null,
  "property_address_city": "Tucson",
  "property_address_state": "AZ",
  "property_address_zip_full": null,
  "property_address_zip": "85745",
  "property_address_country": "US",
  "property_address_county": "Pima County",
  "property_neighborhood_address": "Haven Ridge",
  "property_address_latitude": "32.2224495",
  "property_address_longitude": "-111.0270285",
  "property_email": null,
  "property_phone": "(866) 521-5882",
  "property_call_tracking_phone": "844-888-3690",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Sonoran Reserve in Tucson, AZ, your perfect home awaits, from cozy one-bedroom nooks to spacious four-bedroom retreats. Enjoy a vibrant community rich with amenities like a refreshing pool, state-of-the-art fitness center, and a pet-friendly dog park. Experience comfort and convenience – your new adventure starts here!",
  "property_long_description": "Welcome to Sonoran Reserve, your ultimate apartment community in the heart of Tucson, AZ, where modern living meets comfort and convenience. Choose from an array of thoughtfully designed floor plans, including spacious one, two, three, and four-bedroom apartments, each tailored to fit your lifestyle. \n\nEnjoy a wide range of top-notch amenities that elevate your living experience. Dive into our refreshing pool, stay fit in our fully-equipped fitness center, or unwind in the clubhouse with friends. Other perks include controlled access, a gated community, and a dedicated property manager available on-site for your convenience. \n\nPet owners will love the pet play area and the nearby dog park, ensuring your furry friends feel right at home. Plus, planned social activities foster a vibrant community atmosphere. Enjoy the luxury of in-unit features like high-speed internet access, stainless steel appliances, walk-in closets, and private balconies or patios that invite relaxation while taking in stunning views.\n\nFrom 24-hour access to package services and door-to-door trash pickup, everything you need is just moments away. Our community also offers wheelchair accessibility and ample storage options to cater to all lifestyles. \n\nDon't miss out on a chance to experience life at Sonoran Reserve. Find your new home today—browse our availability or schedule a tour to explore our inviting community. Embrace a lifestyle where comfort meets convenience in Tucson's most sought-after apartment destination!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f66a9-6e81-768b-bad5-3f0d63625c90.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of a resort-style swimming pool with palm trees and a basketball court.",
    "public_id": "019f66a9-6e81-768b-bad5-3f0d63625c90",
    "storage_key": "property/6767906449166453/019f66a9-6e81-768b-bad5-3f0d63625c90.webp",
    "width": 1920,
    "height": 1440
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166453/019ffc3b-b342-75f4-84bb-a2b34209df76.m4v",
  "property_featured_video_media": {
    "public_id": "019ffc3b-b342-75f4-84bb-a2b34209df76",
    "storage_key": "property/6767906449166453/019ffc3b-b342-75f4-84bb-a2b34209df76.m4v",
    "thumbnail_key": "property/6767906449166453/019ffc3b-b342-75f4-84bb-a2b34209df76_thumb.webp",
    "size_bytes": 26131538,
    "classification": "Apartment",
    "title": "Modern Apartment with Pool and Gym Amenities",
    "description": "Discover comfortable living in this apartment community featuring a refreshing pool, a well-equipped gym, and modern interiors."
  },
  "property_total_units": "272",
  "property_year_built": "2000",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.38235294117648",
  "property_admin_fee": "300",
  "property_application_fee": "70",
  "property_fees_deposit_info": "Security Deposit\n$350-1 Month's Rent",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Maximum of 2 pets per unit.",
  "property_pet_policy_description": "We welcome cats and dogs. Non‑refundable pet fee: $500 for one pet, $800 for two pets. Monthly pet rent: $30 for one pet, $60 for two pets. Maximum of 2 pets per unit.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://sonoranreserve.goprisma.com/auth/login",
  "property_apply_now_url": "https://www.myrentalapplication.com/index/amcsonoranreserve",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cf-9ec6-75e8-871b-b885c4baa767.webp",
  "property_primary_logo_media": {
    "alt_text": "Sonoran Reserve Apartments logo",
    "public_id": "019d02cf-9ec6-75e8-871b-b885c4baa767",
    "storage_key": "property/6767906449166453/019d02cf-9ec6-75e8-871b-b885c4baa767.webp",
    "width": 516,
    "height": 150
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cf-8695-7315-917e-714d8eea3ee6.webp",
  "property_secondary_logo_media": {
    "alt_text": "Apartment Management Consultants logo.",
    "public_id": "019d02cf-8695-7315-917e-714d8eea3ee6",
    "storage_key": "property/6767906449166453/019d02cf-8695-7315-917e-714d8eea3ee6.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cf-ba31-70d8-b1a2-63e5fff9b8be.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Sonoran Reserve Apartments logo",
    "public_id": "019d02cf-ba31-70d8-b1a2-63e5fff9b8be",
    "storage_key": "property/6767906449166453/019d02cf-ba31-70d8-b1a2-63e5fff9b8be.webp",
    "width": 516,
    "height": 150
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cf-9ec6-75e8-871b-b885c4baa767.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Sonoran Reserve Apartments logo",
    "public_id": "019d02cf-9ec6-75e8-871b-b885c4baa767",
    "storage_key": "property/6767906449166453/019d02cf-9ec6-75e8-871b-b885c4baa767.webp",
    "width": 516,
    "height": 150
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": "#f9f9f9",
  "property_bedrooms_range": "1 - 4",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "4",
  "property_bathrooms_range": "1 - 4",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "4",
  "property_sqft_range": "457 - 1365",
  "property_sqft_min": "457",
  "property_sqft_max": "1365",
  "property_price_range": null,
  "property_price_min": "1066",
  "property_price_max": null,
  "property_available_units": 18,
  "property_facebook_url": "https://www.facebook.com/SonoranRes",
  "property_instagram_url": "https://www.instagram.com/sonoranreserve",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJESj_-OZ21oYRwaPFOFYQgeg",
  "property_youtube_url": "https://www.youtube.com/watch?v=TLVUGEphb6c#:~:text=Sam%20Hughes%20is%20a%20historic,like%20to%20see%20next...",
  "property_yelp_url": "https://m.yelp.com/search?find_desc=brushfire&find_loc=W+Cortaro+Farms+Rd%2C+Tucson%2C+AZ+85741",
  "property_tiktok_url": "https://www.tiktok.com/@happilypinkblog/photo/7520018985379826958",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Sonoran Reserve",
  "property_home_romance_title": "Embrace Life in Your Perfect Apartment Paradise",
  "property_home_amenities_blurb": "Experience the allure of Sonoran Reserve in Tucson, AZ, where comfort meets convenience. Choose from spacious one to four-bedroom floor plans, and dive into our resort-style amenities including a sparkling pool, fitness center, and dog park. Elevate your lifestyle in a community designed for relaxation and engagement.",
  "property_home_floorplans_blurb": "At Sonoran Reserve in the vibrant heart of Tucson, AZ, your ideal living space awaits. From cozy one-bedroom retreats to spacious four-bedroom layouts, our thoughtfully designed floor plans cater to every lifestyle. Browse our available apartment homes and unlock the door to your next adventure today!",
  "property_home_gallery_blurb": "At Sonoran Reserve in Tucson, AZ, your dream apartment awaits! Choose from spacious one to four-bedroom floor plans designed for comfort and style. Enjoy exceptional amenities like a refreshing pool, state-of-the-art fitness center, and vibrant social activities. Picture yourself living here, where luxury meets community. Your oasis is just a key fob away!",
  "property_home_neighborhood_blurb": "At Sonoran Reserve in vibrant Tucson, AZ, our diverse floor plans, from cozy one-bedroom to spacious four-bedroom apartments, cater to every lifestyle. Enjoy the rich cultural tapestry nearby with easy access to the University of Arizona, Tumamoc Hill, and Tucson Museum of Art. Embrace a community where adventure meets comfort!",
  "property_home_reviews_blurb": "Nestled in the stunning landscapes of Tucson, Sonoran Reserve offers a captivating community where breathtaking mountain views meet exceptional living. Residents rave about our friendly staff and vibrant amenities, saying, “They throw AMAZING pool parties...that make you feel like home with family for a BBQ.” Discover your new home today!",
  "property_neighborhood_blurb": "Nestled in the vibrant heart of Tucson, Sonoran Reserve offers more than just stylish one to four-bedroom floor plans. Enjoy easy access to cultural hotspots like the Tucson Museum of Art, the Children's Museum, and the scenic Tumamoc Hill hiking trail. Experience a community where convenience meets adventure!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Sonoran Reserve in Tucson, AZ, our vibrant community harmonizes comfort and convenience. Indulge in stunning one to four-bedroom floor plans, rejuvenate at the pool, or challenge friends on the basketball court. With chic features and a pet-friendly atmosphere, life here is effortlessly fulfilling. Come enjoy your perfect sanctuary today!",
  "property_applynow_blurb": "At Sonoran Reserve in Tucson, AZ, your lifestyle meets luxury with spacious one to four-bedroom floor plans. Dive into a world of amenities, from a refreshing pool and inviting hot tub to a vibrant dog park and fitness center. Lease online today and elevate your living experience!",
  "property_contactus_blurb": "At Sonoran Reserve in Tucson, AZ, our thoughtfully designed floor plans cater to every lifestyle, offering one to four-bedroom options. Each spacious home invites comfort and style. Have questions? Our friendly leasing team is here to assist you—reach out today to find your perfect apartment!",
  "property_faqs_blurb": "At Sonoran Reserve in Tucson, AZ, our diverse floor plans cater to every lifestyle, offering one to four-bedroom options. Have questions about our vibrant community? Uncover the answers you seek—head over to our FAQs page for everything you need to know about living at Sonoran Reserve! ",
  "property_floorplans_blurb": "At Sonoran Reserve in Tucson, AZ, our diverse floor plans cater to every lifestyle. From cozy one-bedroom retreats to spacious four-bedroom havens, each layout is designed with comfort and style in mind. Browse our available apartment homes and envision your ideal living space today! ",
  "property_gallery_blurb": "At Sonoran Reserve in vibrant Tucson, AZ, your ideal home awaits! Choose from spacious one to four-bedroom floor plans, each designed for comfort and style. Enjoy inviting amenities like a sparkling pool, modern fitness center, pet-friendly spaces, and more. Picture yourself living here, where luxury meets lifestyle!",
  "property_interactivemap_blurb": "At Sonoran Reserve in Tucson, AZ, a vibrant lifestyle awaits you. Choose from spacious one to four-bedroom floor plans, each designed for comfort. Enjoy exceptional amenities like a refreshing pool, fitness center, and pet-friendly areas. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Sonoran Reserve in Tucson, AZ, your furry friends are cherished as family! With a spacious community designed for both pets and people, enjoy life with up to two beloved companions. Our inviting pet policy ensures your pets have room to run, play, and thrive in a vibrant home.",
  "property_referafriend_blurb": "At Sonoran Reserve in beautiful Tucson, AZ, our diverse floor plans—ranging from cozy one-bedroom retreats to spacious four-bedroom havens—are perfect for every lifestyle. Great friends make great neighbors, so refer a friend to join our vibrant community today and elevate your living experience!",
  "property_residentaccess_blurb": "Welcome to Sonoran Reserve in Tucson, AZ, where comfort meets convenience. Choose from our spacious one to four-bedroom floor plans, tailored to fit your lifestyle. Ready to simplify your living experience? Access your resident portal today for rent payments, maintenance requests, and all your community needs!",
  "property_reviews_blurb": "At Sonoran Reserve in Tucson, AZ, residents rave about the \"absolutely lovely community\" and the \"amazing views\" that redefine luxury living. With friendly staff ready to assist, BBQ pool parties, and a pristine environment, it’s more than just an apartment; it's home. Read what our residents cherish most! ",
  "property_created_at": "1759782593925",
  "property_scheduletour_blurb": "At Sonoran Reserve in Tucson, AZ, choose from spacious one to four-bedroom floor plans tailored to your lifestyle. Experience modern living and vibrant community vibes. Ready to find your perfect home? Schedule a tour today and see what our residents love about living here! Your new adventure awaits!",
  "property_thankyou_blurb": "Thank you for reaching out to Sonoran Reserve in beautiful Tucson, AZ! Your interest is important to us, and a dedicated team member will connect with you shortly. With an array of thoughtfully designed floor plans, including one to four-bedroom options, your ideal home awaits at Sonoran Reserve.",
  "property_virtualtours_blurb": "Welcome to Sonoran Reserve in Tucson, AZ, where modern living meets desert charm. Choose from spacious one to four-bedroom floor plans that cater to your lifestyle. Experience the vibrant community and beautiful surroundings—take a virtual tour today and envision your new home in this stunning oasis!",
  "property_copyright": "2025 All Rights Reserved. Sonoran Reserve",
  "property_seo_title_home": "Apartments for Rent in Tucson, AZ | Sonoran Reserve | Home",
  "property_seo_description_home": "Discover apartments for rent in Tucson, AZ at Sonoran Reserve. Choose from 1-4-bedroom homes with amenities and Sonoran Desert views near the University of AZ.",
  "property_seo_title_floorplans": "2-Bedroom Apts in Tucson, AZ | Sonoran Reserve | Floor Plans",
  "property_seo_description_floorplans": "Explore 1-bedroom apartments in Tucson, AZ, at Sonoran Reserve, along with spacious 2, 3, and 4-bedroom options.",
  "property_seo_title_amenities": "Tucson, AZ Apartments | Sonoran Reserve | Amenities",
  "property_seo_description_amenities": "Our Tucson, AZ apartments offer standout amenities, including a refreshing pool, fitness center, on-site dog park, and scenic Sonoran Desert views.",
  "property_seo_title_gallery": "Apartments in Tucson, AZ | Sonoran Reserve | Gallery",
  "property_seo_description_gallery": "Browse photos of apartments in Tucson, AZ at Sonoran Reserve. View stylish interiors and community amenities like a pool, fitness center, and dog park.",
  "property_seo_title_virtualtours": "Tucson, AZ Apts for Rent | Sonoran Reserve | Virtual Tours",
  "property_seo_description_virtualtours": "Take a virtual tour of Tucson, AZ apartments for rent at Sonoran Reserve. Explore 1–4 bedroom homes and resort-style amenities from anywhere.",
  "property_seo_title_interactivemap": "Map | Tucson Apartments",
  "property_seo_description_interactivemap": "Sonoran Reserve is in Tucson, AZ, near University of Arizona, Tucson Museum of Art, & El Rio Golf Course. View our map of our apartments!",
  "property_seo_title_neighborhood": "Rentals in Tucson, AZ | Sonoran Reserve | Neighborhood",
  "property_seo_description_neighborhood": "Check out our rentals in Tucson, AZ, near the University of AZ, Tumamoc Hill, and Tucson Museum of Art. We offer convenience, charm, and scenic surroundings.",
  "property_seo_title_contact": "Tucson, AZ Rentals | Sonoran Reserve | Contact Us",
  "property_seo_description_contact": "Contact Sonoran Reserve about our Tucson, AZ rentals. Learn more about our 1–4 bedroom apartments, pet-friendly community, and convenient Tucson location.",
  "property_seo_title_faqs": "FAQs | Apartments in Tucson, AZ",
  "property_seo_description_faqs": "Unlock the answers to your questions at Sonoran Reserve! From floor plans to amenities, our FAQs provide all the details you need about your new home.",
  "property_seo_title_reviews": "Reviews | Apartments in Tucson, AZ",
  "property_seo_description_reviews": "Explore feedback from residents of Sonoran Reserve! Learn firsthand experiences and gain insights into our vibrant apartment community in Tucson, AZ.",
  "property_seo_title_applynow": "Tucson, AZ Apts | Sonoran Reserve | Apply Now",
  "property_seo_description_applynow": "Apply for Tucson, AZ, apts at Sonoran Reserve. Choose from various floor plans in a pet-friendly community near the University of AZ and local attractions.",
  "property_seo_title_residentaccess": "Resident Access | Tucson Apartments for Rent",
  "property_seo_description_residentaccess": "With convenient 24/7 access, the resident portal makes it easy for you to request maintenance service and pay your rent online. Log in to get started.",
  "property_seo_title_referafriend": "Refer a Friend | Apartments in Tucson, AZ",
  "property_seo_description_referafriend": "Refer a friend to Sonoran Reserve and both of you can enjoy fantastic perks. Spread the word!",
  "property_seo_title_scheduletour": "Apts in Tucson, AZ | Sonoran Reserve | Schedule a Tour",
  "property_seo_description_scheduletour": "Schedule a tour of apts in Tucson, AZ at Sonoran Reserve. Walk through spacious 1–4 bedroom homes with a pool, fitness center, dog park, and scenic views.",
  "property_seo_title_privacy": "4-Bed Apts in Tucson, AZ | Sonoran Reserve | Privacy Policy",
  "property_seo_description_privacy": "Your peace of mind matters. At Sonoran Reserve in Tucson, AZ, safeguard your personal information. Curious about our practices? View our privacy policy today!",
  "property_seo_title_accessibility": "3-Bedroom Apts in Tucson | Sonoran Reserve | Accessibility",
  "property_seo_description_accessibility": "At Sonoran Reserve in Tucson, AZ, we're committed to digital inclusion. Learn how we ensure all residents enjoy equal access to our community online.",
  "property_seo_title_sitemap": "Spacious Rentals in Tucson, AZ | Sonoran Reserve | Sitemap",
  "property_seo_description_sitemap": "Unlock the full experience at Sonoran Reserve in Tucson, AZ. Navigate our sitemap to find your dream apartment and amenities designed for upscale living!",
  "property_seo_title_thankyou": "Apts for Rent in Tucson, AZ | Sonoran Reserve | Thank You",
  "property_seo_description_thankyou": "Thank you for your interest in Sonoran Reserve. We will process your request and get back to you shortly!",
  "property_seo_title_pets": "Pet-Friendly Apts in Tucson, AZ | Sonoran Reserve | Pets",
  "property_seo_description_pets": "We offer pet-friendly apartments in Tucson, AZ, at Sonoran Reserve. Enjoy our on-site dog park, spacious floor plans, and beautiful Sonoran surroundings.",
  "property_updated_at": "1786643202745",
  "amenities": [
    {
      "id": "custom_e86394ca-4e68-4c6a-a6d9-3122ee529844",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Basketball Court",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_6027faec-f443-4a19-a53f-334b63c3117c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ed4e3531-f30d-4719-aec3-2e6b0e1df8fd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "State-Of-The-Art Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_48872463-a2aa-47cf-9536-721272715a10",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Shimmering Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_77eef51b-6041-4f06-9ded-1445c54b12aa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Soothing Spa",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_eaceacd0-99c3-47ce-b1e8-788ea114589f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "State-Of-The-Art Package System",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_703d6fd0-d07b-46a2-a6ba-76d8de82030b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Professional and Responsive Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_67143137-a13a-41f2-984c-c0f3e30ca7d7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Convenient Location",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_af6b75a6-7ee0-4fcc-82f9-82e75aa37e42",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Central Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_cc822868-6c33-4237-8e36-4d33874c09e6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Tile Backsplash*",
      "amount": "false",
      "description": "In Select Units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e1cf877c-2786-4412-ba3e-98fedb25742a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "In Unit Washer/Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e256f53b-46a6-4aa0-b4a3-0d4ec732b557",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_93395170-c8f6-4853-bf40-c5bd63f17095",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Private Balcony/Patio*",
      "amount": "false",
      "description": "In Select Units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_cb99d851-bd00-4758-a038-f560cfdeffed",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_2edd6a53-e355-4f24-8d4c-11d08019a36f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Fully Equipped Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_4a746f6b-caa1-44b2-8f5e-0396eefd7113",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steal Appliances*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_36633178-9faf-47ef-8f50-ec02f18a8e4c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Peninsula*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_1bdaf6a2-560b-4d26-8cae-099076a71903",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Wood Inspired Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a106862a-cbc4-4957-80bc-eb61980f5d61",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Fiber Optic Internet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_325db8f5-da15-4e1c-b25b-ae108b5529d4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Modern Cabinetry*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_94cb7ffd-f9ee-427c-b61d-807ce68f3a59",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Game Center w/ Shuffle Board and Ping-Pong",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_b8ddaee7-86f3-4389-a329-932a08ee1fcd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Gated Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_cd8e43f7-3dbf-4553-8381-e547e5f58f23",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_342cc5f8-21d4-466e-b787-80fa42ecfc5c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Valet Trash Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_18ecb06e-11dc-4a08-8c0b-e13de6582f65",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Complimentary Coffee Bar",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_b2e96def-9045-451f-875b-59bf23b24519",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "Elaborate Entertainment Lounge w/Wifi",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_29a7747f-56ac-49dc-8176-79c841a208af",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "external_id": "false",
      "title": "BBQ Grill Area w/Outdoor Seating",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_205f1ca4-8ea1-4de9-b899-13dde091b967",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/01a01703-4e7c-7660-bba8-9777286edd8a.webp",
      "image_media": {
        "alt_text": "Leasing office building exterior with Spanish tile roof and palm trees at Sonoran Reserve in Tucson, AZ.",
        "public_id": "01a01703-4e7c-7660-bba8-9777286edd8a",
        "storage_key": "property/6767906449166453/01a01703-4e7c-7660-bba8-9777286edd8a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our leasing office! Stop by to tour our community and learn more about our apartment homes. We look forward to meeting you.",
      "link": "",
      "alt_text": "Leasing office building exterior with Spanish tile roof and palm trees at Sonoran Reserve in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c744de34-2e7a-4122-afc1-b6cfe441c3ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/01a01703-1385-755a-8223-4008161fd360.webp",
      "image_media": {
        "alt_text": "Modern kitchen with blue brick backsplash, stainless steel appliances, and island seating at Sonoran Reserve in Tucson, AZ.",
        "public_id": "01a01703-1385-755a-8223-4008161fd360",
        "storage_key": "property/6767906449166453/01a01703-1385-755a-8223-4008161fd360.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stylish kitchen featuring sleek cabinetry, a vibrant blue brick backsplash, and a breakfast bar with orange stools, perfect for modern living.",
      "link": "",
      "alt_text": "Modern kitchen with blue brick backsplash, stainless steel appliances, and island seating at Sonoran Reserve in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6dd69c40-1561-417d-9b0a-f632f9216c93",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/01a01703-3650-701f-a722-7676c67e643c.webp",
      "image_media": {
        "alt_text": "Ping pong table and shuffleboard in a community game room with large windows at Sonoran Reserve in Tucson, AZ.",
        "public_id": "01a01703-3650-701f-a722-7676c67e643c",
        "storage_key": "property/6767906449166453/01a01703-3650-701f-a722-7676c67e643c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy hours of fun in our community game room, featuring a ping pong table and shuffleboard, perfect for friendly competition.",
      "link": "",
      "alt_text": "Ping pong table and shuffleboard in a community game room with large windows at Sonoran Reserve in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_03e7db65-16de-428f-9fa1-75679caab3ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f778b-0edc-73b8-94d5-6edd1c3674b1.webp",
      "image_media": {
        "alt_text": "Modern lounge area with colorful accent wall, foosball table, and view of the pool at Sonoran Reserve in Tucson, AZ.",
        "public_id": "019f778b-0edc-73b8-94d5-6edd1c3674b1",
        "storage_key": "property/6767906449166453/019f778b-0edc-73b8-94d5-6edd1c3674b1.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and socialize in our vibrant community lounge, featuring a foosball table and direct access to the sparkling pool area.",
      "link": "",
      "alt_text": "Modern lounge area with colorful accent wall, foosball table, and view of the pool at Sonoran Reserve in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4dd1ba50-faeb-4c44-b1ad-6581dc3271f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/01a01703-5a39-736d-8039-876bd9844e67.webp",
      "image_media": {
        "alt_text": "Modern lounge area with sofas, tables, chairs, and a colorful geometric mural at Sonoran Reserve in Tucson, AZ.",
        "public_id": "01a01703-5a39-736d-8039-876bd9844e67",
        "storage_key": "property/6767906449166453/01a01703-5a39-736d-8039-876bd9844e67.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring comfortable seating, dining areas, and vibrant artwork.",
      "link": "",
      "alt_text": "Modern lounge area with sofas, tables, chairs, and a colorful geometric mural at Sonoran Reserve in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_687a9450-c7e7-479c-89ca-f4cc9bd2b35c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/01a01703-3e94-7078-8a07-e4c71cbe398b.webp",
      "image_media": {
        "alt_text": "Lobby with Luxer One package lockers, a blue sofa, and accent chairs at Sonoran Reserve in Tucson, AZ.",
        "public_id": "01a01703-3e94-7078-8a07-e4c71cbe398b",
        "storage_key": "property/6767906449166453/01a01703-3e94-7078-8a07-e4c71cbe398b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and recharge in our stylish lobby, featuring convenient Luxer One package lockers and comfortable seating areas.",
      "link": "",
      "alt_text": "Lobby with Luxer One package lockers, a blue sofa, and accent chairs at Sonoran Reserve in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ec1da0cd-0d0b-4e1a-a0ff-ae19c61d26af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/01a01703-08df-74ba-b5ff-7f606f5caca9.webp",
      "image_media": {
        "alt_text": "Modern lounge area with colorful accent wall, seating, and high-top tables at Sonoran Reserve in Tucson, AZ.",
        "public_id": "01a01703-08df-74ba-b5ff-7f606f5caca9",
        "storage_key": "property/6767906449166453/01a01703-08df-74ba-b5ff-7f606f5caca9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating, vibrant decor, and convenient high-top tables for socializing.",
      "link": "",
      "alt_text": "Modern lounge area with colorful accent wall, seating, and high-top tables at Sonoran Reserve in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_01b03d54-8244-4591-9fed-d4b8506ca068",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/01a01703-6f11-71cb-849b-099e7ed43b24.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and free weights at Sonoran Reserve in Tucson, AZ.",
        "public_id": "01a01703-6f11-71cb-849b-099e7ed43b24",
        "storage_key": "property/6767906449166453/01a01703-6f11-71cb-849b-099e7ed43b24.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, fully equipped with cardio machines, weight-training equipment, and free weights to help you achieve your wellness goals.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and free weights at Sonoran Reserve in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_113d48db-d1f1-4f3f-8d0c-8c941b491a92",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/01a01703-57ed-712e-88b3-c831c787f7c8.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style pool and basketball court with desert mountain backdrop at Sonoran Reserve in Tucson, AZ.",
        "public_id": "01a01703-57ed-712e-88b3-c831c787f7c8",
        "storage_key": "property/6767906449166453/01a01703-57ed-712e-88b3-c831c787f7c8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience resort-style living with our sparkling pool and recreational basketball court, all set against a stunning desert mountain landscape.",
      "link": "",
      "alt_text": "Aerial view of a resort-style pool and basketball court with desert mountain backdrop at Sonoran Reserve in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fcc2c895-86e1-48a9-a0e6-b292e89839d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/01a01703-5339-75aa-bf3b-3c48c6f599b4.webp",
      "image_media": {
        "alt_text": "Resort-style pool and hot tub area with lounge chairs and umbrellas, surrounded by apartment buildings and landscaping at Sonoran Reserve in Tucson, AZ.",
        "public_id": "01a01703-5339-75aa-bf3b-3c48c6f599b4",
        "storage_key": "property/6767906449166453/01a01703-5339-75aa-bf3b-3c48c6f599b4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool and relaxing hot tub, perfect for unwinding under the sun. Ample lounge seating and shaded areas make it an oasis for relaxation.",
      "link": "",
      "alt_text": "Resort-style pool and hot tub area with lounge chairs and umbrellas, surrounded by apartment buildings and landscaping at Sonoran Reserve in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aaf2b596-cc83-4669-91b3-af6a53b77ca1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/01a01705-b5bb-70f5-a451-9cfbdba3ee7b.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by palm trees and apartment buildings.",
        "public_id": "01a01705-b5bb-70f5-a451-9cfbdba3ee7b",
        "storage_key": "property/6767906449166453/01a01705-b5bb-70f5-a451-9cfbdba3ee7b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with comfortable lounge chairs and shaded umbrellas. A perfect oasis for relaxation and fun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by palm trees and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5e67942a-e1b7-4337-a804-36c0aa4991fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/01a01702-e1eb-7039-96da-8e3859aaeddf.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and palm trees.",
        "public_id": "01a01702-e1eb-7039-96da-8e3859aaeddf",
        "storage_key": "property/6767906449166453/01a01702-e1eb-7039-96da-8e3859aaeddf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our stunning resort-style swimming pool. Perfect for soaking up the sun or taking a refreshing dip, our pool area features comfortable lounge chairs and shaded umbrellas for your convenience.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9c14e470-f002-466c-b967-4339c88fd211",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/01a01703-31f7-712c-ab7d-803a6f440506.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and umbrellas at Sonoran Reserve in Tucson, AZ.",
        "public_id": "01a01703-31f7-712c-ab7d-803a6f440506",
        "storage_key": "property/6767906449166453/01a01703-31f7-712c-ab7d-803a6f440506.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool and therapeutic hot tub. Perfect for soaking up the sun or enjoying a cool dip on a warm day.",
      "link": "",
      "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and umbrellas at Sonoran Reserve in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_685c8556-03ee-4e4d-919e-318006f524f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/01a01702-f3f3-75eb-9c45-c04b68b66689.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with stainless steel grills and seating.",
        "public_id": "01a01702-f3f3-75eb-9c45-c04b68b66689",
        "storage_key": "property/6767906449166453/01a01702-f3f3-75eb-9c45-c04b68b66689.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy al fresco dining at our community grilling stations, perfect for gathering with friends and neighbors.",
      "link": "",
      "alt_text": "Outdoor grilling area with stainless steel grills and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_60c26da3-5227-43ba-a109-6fa0a7cabcdf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/01a01703-353c-757e-92c8-bbb725a1be94.webp",
      "image_media": {
        "alt_text": "Outdoor basketball court with apartment buildings in the background at Sonoran Reserve in Tucson, AZ.",
        "public_id": "01a01703-353c-757e-92c8-bbb725a1be94",
        "storage_key": "property/6767906449166453/01a01703-353c-757e-92c8-bbb725a1be94.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a game of basketball on our full-sized court, perfect for staying active and having fun outdoors. Located conveniently on the property for easy access.",
      "link": "",
      "alt_text": "Outdoor basketball court with apartment buildings in the background at Sonoran Reserve in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0a1157fb-7fe0-4a51-bfed-64db98ffc253",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/01a01702-c737-72de-a66f-b2ff428cebbd.webp",
      "image_media": {
        "alt_text": "Outdoor area with a basketball court and green space, surrounded by apartment buildings.",
        "public_id": "01a01702-c737-72de-a66f-b2ff428cebbd",
        "storage_key": "property/6767906449166453/01a01702-c737-72de-a66f-b2ff428cebbd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoor amenities at our community, including a basketball court and a dedicated green space perfect for relaxation and recreation.",
      "link": "",
      "alt_text": "Outdoor area with a basketball court and green space, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fb3c7bb2-98b0-496a-b397-f9a734b816d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/01a0170d-470b-7145-a128-ba565a1bcc46.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and subway tile backsplash at Sonoran Reserve in Tucson, AZ.",
        "public_id": "01a0170d-470b-7145-a128-ba565a1bcc46",
        "storage_key": "property/6767906449166453/01a0170d-470b-7145-a128-ba565a1bcc46.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, ample cabinet space, and a convenient breakfast bar. Perfect for home chefs and entertainers.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and subway tile backsplash at Sonoran Reserve in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_106e6b47-913c-4151-9e47-4d522a52839f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/01a01703-09f3-779e-9efa-6b720ec7d219.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and a breakfast bar with bar stools.",
        "public_id": "01a01703-09f3-779e-9efa-6b720ec7d219",
        "storage_key": "property/6767906449166453/01a01703-09f3-779e-9efa-6b720ec7d219.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This modern apartment kitchen features sleek gray cabinetry, stainless steel appliances, a spacious sink, and a convenient breakfast bar perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and a breakfast bar with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_66f55d09-91c2-453e-a019-b6a4ed258485",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/01a01705-9ab6-7666-9367-ae683bad852a.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with island seating, sofa, coffee table, and dining area at Sonoran Reserve in Tucson, AZ.",
        "public_id": "01a01705-9ab6-7666-9367-ae683bad852a",
        "storage_key": "property/6767906449166453/01a01705-9ab6-7666-9367-ae683bad852a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen area featuring a kitchen island with bar stools, a comfortable sofa, a coffee table, and a dining area. Perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area with island seating, sofa, coffee table, and dining area at Sonoran Reserve in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d9093e5a-046e-4392-9022-01ae0e23d7a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/01a01703-3a9a-7059-88bb-909097dfdbcb.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and ceiling fan at Sonoran Reserve in Tucson, AZ.",
        "public_id": "01a01703-3a9a-7059-88bb-909097dfdbcb",
        "storage_key": "property/6767906449166453/01a01703-3a9a-7059-88bb-909097dfdbcb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sectional sofa, a modern coffee table, and a convenient ceiling fan, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with a sectional sofa, coffee table, and ceiling fan at Sonoran Reserve in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d1171ceb-4256-45b7-b34f-a62277439b9e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/01a01703-77c5-76ed-b6ec-3e68f92ee630.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a large white comforter, wood-framed bed, and a view into a modern bathroom at Sonoran Reserve in Tucson, AZ.",
        "public_id": "01a01703-77c5-76ed-b6ec-3e68f92ee630",
        "storage_key": "property/6767906449166453/01a01703-77c5-76ed-b6ec-3e68f92ee630.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, featuring a plush queen-size bed and elegant decor. The adjoining bathroom offers modern amenities for your convenience.",
      "link": "",
      "alt_text": "Cozy bedroom with a large white comforter, wood-framed bed, and a view into a modern bathroom at Sonoran Reserve in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dcb6d85d-c974-475e-a015-5903262a6b7e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/01a01703-9017-7399-9647-9c217328300a.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with sink at Sonoran Reserve in Tucson, AZ.",
        "public_id": "01a01703-9017-7399-9647-9c217328300a",
        "storage_key": "property/6767906449166453/01a01703-9017-7399-9647-9c217328300a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Freshen up in the modern bathroom, complete with a clean bathtub, convenient toilet, and a spacious vanity with a sink.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with sink at Sonoran Reserve in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_002216cf-97f2-484f-b8cc-187948967b1b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "1940 E Broadway Blvd, Tucson, AZ 85719, USA",
      "poi_short_description": "Supermarket offering fresh produce, deli items, baked goods and meat, plus a pharmacy.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, meats, and seafood, as well as a bakery with delicious breads, bagels, and desserts. They also highlight the clean and well-stocked store, the friendly and helpful staff, and the convenient self-checkout.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-f293-714c-a5ce-f0a1a5b25941.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-f293-714c-a5ce-f0a1a5b25941",
        "storage_key": "property/6767906449166453/019d02cc-f293-714c-a5ce-f0a1a5b25941.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.safeway.com/safeway/az/tucson/1940-e-broadway-blvd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16059534047043118201&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "32.2200633",
      "poi_longitude": "-110.9429555",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 520-206-9047",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-3ca8-7397-a6e2-5605e1ef82ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-3ca8-7397-a6e2-5605e1ef82ab",
        "storage_key": "property/6767906449166453/019d02cd-3ca8-7397-a6e2-5605e1ef82ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDZc2QFFw1oYReeRL9CDt3t4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d4471487-0b9f-4283-b38f-fa97fea4b47c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "The University of Arizona",
      "poi_type": "Education",
      "poi_address": "1200 E University Blvd, Tucson, AZ 85721, USA",
      "poi_short_description": "Public research university founded in 1885 & known for its sports & science programs.",
      "poi_long_description": "Public research university founded in 1885 & known for its sports & science programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-fb43-77c3-bbaa-de4a5360005c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-fb43-77c3-bbaa-de4a5360005c",
        "storage_key": "property/6767906449166453/019d02cc-fb43-77c3-bbaa-de4a5360005c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.arizona.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10112948138785427302&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-university-of-arizona",
      "poi_latitude": "32.2318981",
      "poi_longitude": "-110.9535407",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 520-621-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-3ccf-724a-8ab4-fc8e6c26fc7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-3ccf-724a-8ab4-fc8e6c26fc7a",
        "storage_key": "property/6767906449166453/019d02cd-3ccf-724a-8ab4-fc8e6c26fc7a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTZpd7qpx1oYRZs9AZMBoWIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e3704397-fd1d-468a-b21e-60b2da27d4d3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Pima Community College - West Campus",
      "poi_type": "Education",
      "poi_address": "2202 W Anklam Rd, Tucson, AZ 85709, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-fae1-76c9-98e1-d9641ca306d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-fae1-76c9-98e1-d9641ca306d8",
        "storage_key": "property/6767906449166453/019d02cc-fae1-76c9-98e1-d9641ca306d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pima.edu/maps-directions/west-campus.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=8793938502825452497&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pima-community-college---west-campus",
      "poi_latitude": "32.2275798",
      "poi_longitude": "-111.0165142",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 520-206-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-3ccf-724a-8ab4-fc8e6c26fc7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-3ccf-724a-8ab4-fc8e6c26fc7a",
        "storage_key": "property/6767906449166453/019d02cd-3ccf-724a-8ab4-fc8e6c26fc7a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_8bxCcR21oYR0aOK3XlYCno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f2780618-11a5-4b5c-b0af-71f1a20b9716",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Pima Community College - Downtown Campus",
      "poi_type": "Education",
      "poi_address": "1255 N Stone Ave, Tucson, AZ 85709, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-0015-732e-bb7b-b6f402303876.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-0015-732e-bb7b-b6f402303876",
        "storage_key": "property/6767906449166453/019d02cd-0015-732e-bb7b-b6f402303876.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.pima.edu/about-pima/locations/downtown/index.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=4968032056070325903&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pima-community-college---downtown-campus",
      "poi_latitude": "32.2370859",
      "poi_longitude": "-110.9729433",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 520-206-7171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-3ccf-724a-8ab4-fc8e6c26fc7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-3ccf-724a-8ab4-fc8e6c26fc7a",
        "storage_key": "property/6767906449166453/019d02cd-3ccf-724a-8ab4-fc8e6c26fc7a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzfy4YBZx1oYRj0bTTtX-8UQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c99894c7-eabe-4bc5-9034-e9a79697c3fd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Children's Museum Tucson",
      "poi_type": "Entertainment",
      "poi_address": "200 S 6th Ave, Tucson, AZ 85701, USA",
      "poi_short_description": "Children's museum featuring interactive exhibits, a Curiosity Courtyard, and special after-hours programs.",
      "poi_long_description": "People say this children's museum offers a wide variety of interactive and educational exhibits, as well as outdoor activities like trikes and bubbles. They highlight the engaging and fun experience for kids of all ages, and the affordable prices. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-08b1-7734-9381-5bd6efdd9486.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-08b1-7734-9381-5bd6efdd9486",
        "storage_key": "property/6767906449166453/019d02cd-08b1-7734-9381-5bd6efdd9486.webp",
        "width": 800,
        "height": 500
      },
      "poi_business_url": "https://www.childrensmuseumtucson.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2530958488789789227&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "childrens-museum-tucson",
      "poi_latitude": "32.219192",
      "poi_longitude": "-110.969338",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 520-792-9985",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-41d7-768e-b0dc-08faf0c0287b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-41d7-768e-b0dc-08faf0c0287b",
        "storage_key": "property/6767906449166453/019d02cd-41d7-768e-b0dc-08faf0c0287b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJM7TnXOFw1oYRKyqTAVbFHyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_53f7f268-579c-4a3a-b1cb-baa0e3247e6c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Tucson Museum Of Art",
      "poi_type": "Entertainment",
      "poi_address": "140 N Main Ave, Tucson, AZ 85701, USA",
      "poi_short_description": "Museum with Western and contemporary art, plus Latin American and European collections, and a restaurant.",
      "poi_long_description": "People say this museum offers a diverse collection of art, including contemporary, pre-Columbian, and Spanish colonial works. They highlight the good price, the lovely cafe, and the adjacent buildings on campus. They also like the fun conversation cards that encourage engagement with the art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-0dac-75ac-8eb2-c665b796eeea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-0dac-75ac-8eb2-c665b796eeea",
        "storage_key": "property/6767906449166453/019d02cd-0dac-75ac-8eb2-c665b796eeea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tucsonmuseumofart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5955506489461373436&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tucson-museum-of-art",
      "poi_latitude": "32.2234486",
      "poi_longitude": "-110.9754411",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 520-624-2333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-41d7-768e-b0dc-08faf0c0287b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-41d7-768e-b0dc-08faf0c0287b",
        "storage_key": "property/6767906449166453/019d02cd-41d7-768e-b0dc-08faf0c0287b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1XL3FiBx1oYR_PngOZk1plI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c027bb4e-362e-45b9-9e0c-13be06ebc54e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4240 N 1st Ave, Tucson, AZ 85719, USA",
      "poi_short_description": "Well-maintained, clean health club featuring cardio equipment, free weights, swimming pools, a basketball court, friendly staff, and more.",
      "poi_long_description": "People say this gym offers a wide variety of workout equipment, a heated swimming pool, and group classes. They also highlight the clean facilities, friendly and helpful staff, and welcoming community.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-145b-7057-aaf1-e4a2b9ea9174.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-145b-7057-aaf1-e4a2b9ea9174",
        "storage_key": "property/6767906449166453/019d02cd-145b-7057-aaf1-e4a2b9ea9174.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=369&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11744270032748973419&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "32.2841479",
      "poi_longitude": "-110.9595064",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 520-888-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-41c1-7723-972a-2e31c5528a85",
        "storage_key": "property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoTssNs9z1oYRa41E-F4H_KI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b1dbbe1b-a552-4785-a970-1a4dfe221b67",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3693 S 16th Ave, Tucson, AZ 85713, USA",
      "poi_short_description": "Clean gym that offers classes and equipment for weight training and cardio, plus a sauna.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-185f-701c-91b1-5ebdbd1debc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-185f-701c-91b1-5ebdbd1debc0",
        "storage_key": "property/6767906449166453/019d02cd-185f-701c-91b1-5ebdbd1debc0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/az/ajo-16th/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16793687417034537180&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "32.1794132",
      "poi_longitude": "-110.9807022",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 520-600-2711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-41c1-7723-972a-2e31c5528a85",
        "storage_key": "property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqbCGNadw1oYR3HhKobopD-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_f7f22191-9879-4f37-83d0-1aa962198238",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4755 S Calle Santa Cruz, Tucson, AZ 85714, USA",
      "poi_short_description": "Chain gym offering 24-hour access and a variety of equipment, plus tanning and massage.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-1073-75e9-bfd8-f2c1442a8ee9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-1073-75e9-bfd8-f2c1442a8ee9",
        "storage_key": "property/6767906449166453/019d02cd-1073-75e9-bfd8-f2c1442a8ee9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/tucson-irvington-i-19-az",
      "poi_directions_map_url": "https://maps.google.com/?cid=8490492092384769259&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.1657854",
      "poi_longitude": "-110.9888899",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 520-495-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-41c1-7723-972a-2e31c5528a85",
        "storage_key": "property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFyHtD-971oYR63TbzpJJ1HU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_97b336f4-9e30-4685-9e2e-7b108a4aa545",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Lohse Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "60 W Alameda St, Tucson, AZ 85701, USA",
      "poi_short_description": "Venerable gym, fitness facility featuring clean, modern equipment, an outdoor pool and a welcoming staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-1b29-75ad-85c6-b1da7a089cec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-1b29-75ad-85c6-b1da7a089cec",
        "storage_key": "property/6767906449166453/019d02cd-1b29-75ad-85c6-b1da7a089cec.webp",
        "width": 1280,
        "height": 817
      },
      "poi_business_url": "http://tucsonymca.org/lohse",
      "poi_directions_map_url": "https://maps.google.com/?cid=12439879265858602659&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lohse-family-ymca",
      "poi_latitude": "32.224083",
      "poi_longitude": "-110.972635",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 520-623-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-41c1-7723-972a-2e31c5528a85",
        "storage_key": "property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWy0_xx9x1oYRo8Y_ckhUo6w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_c5db5f2a-af02-4cc0-a2fe-dab12c3790db",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Shopping & Retail",
      "poi_address": "5157 S Calle Santa Cruz, Tucson, AZ 85706, USA",
      "poi_short_description": "Cosmetics, fragrance and skincare retailer featuring a salon for haircuts, brow waxing and makeup services.",
      "poi_long_description": "People say this cosmetics store is clean and offers great deals on a variety of items. They also highlight the friendly and helpful staff who are knowledgeable about skincare.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-13d5-7129-8fec-823514d2d017.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-13d5-7129-8fec-823514d2d017",
        "storage_key": "property/6767906449166453/019d02cd-13d5-7129-8fec-823514d2d017.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/tucson-az-1415",
      "poi_directions_map_url": "https://maps.google.com/?cid=6863164286216985832&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "32.1580496",
      "poi_longitude": "-110.9896973",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "134",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 520-492-2062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-41c1-7723-972a-2e31c5528a85",
        "storage_key": "property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoSqwfgJ71oYR6FwcQ47bPl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_ecbe1b47-3caf-4112-8f1f-f0361b594647",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Veterinary Specialty Center Tucson",
      "poi_type": "Health and Wellness",
      "poi_address": "4909 N La Cañada Dr, Tucson, AZ 85704, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-1c8d-76aa-aabe-2105cb2b637d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-1c8d-76aa-aabe-2105cb2b637d",
        "storage_key": "property/6767906449166453/019d02cd-1c8d-76aa-aabe-2105cb2b637d.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://vscot.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15464959821057098276&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "veterinary-specialty-center-tucson",
      "poi_latitude": "32.2959456",
      "poi_longitude": "-110.9958686",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 520-795-9955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-41c1-7723-972a-2e31c5528a85",
        "storage_key": "property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfWPGyYdz1oYRJALMNwWTntY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_114a7c2d-fbf9-4890-a986-bed964455a3b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Banner - University Medical Center Tucson | Tucson, AZ | Campbell Ave.",
      "poi_type": "Health and Wellness",
      "poi_address": "1625 N Campbell Ave, Tucson, AZ 85719, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-1bd9-70d2-a469-498379697ec9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-1bd9-70d2-a469-498379697ec9",
        "storage_key": "property/6767906449166453/019d02cd-1bd9-70d2-a469-498379697ec9.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/tucson/banner-university-medical-center-tucson?y_source=1_MTE5MDczNzMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5223932672584302058&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "banner---university-medical-center-tucson--tucson-az--campbell-ave",
      "poi_latitude": "32.2429301",
      "poi_longitude": "-110.9462013",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 520-694-0111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-47b8-71fd-a21f-4d28aec29043.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-47b8-71fd-a21f-4d28aec29043",
        "storage_key": "property/6767906449166453/019d02cd-47b8-71fd-a21f-4d28aec29043.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJqYievqZx1oYR6r3xjxYjf0g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_304ef42e-b325-4e81-be44-b334a7de9c95",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Carondelet St. Mary's Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1601 W St Marys Rd, Tucson, AZ 85745, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-20e4-72d7-acbc-948436cfb9a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-20e4-72d7-acbc-948436cfb9a2",
        "storage_key": "property/6767906449166453/019d02cd-20e4-72d7-acbc-948436cfb9a2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.carondelet.org/locations/detail/st-marys-hospital/?utm_campaign=gmb_listings_mgmt&utm_source=gmb-st-marys-hospital&utm_medium=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=9840775461193459625&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "carondelet-st-marys-hospital",
      "poi_latitude": "32.2273302",
      "poi_longitude": "-111.000127",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 520-872-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-47b8-71fd-a21f-4d28aec29043.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-47b8-71fd-a21f-4d28aec29043",
        "storage_key": "property/6767906449166453/019d02cd-47b8-71fd-a21f-4d28aec29043.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJM1a0lNJ21oYRqSfRriR1kYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e31608aa-2faa-4362-9765-399b66132d73",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Tumamoc Hill Hiking Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Tumamoc Hill Rd, Tucson, AZ 85745, USA",
      "poi_short_description": "Peaceful walking & running trail with views on an expansive ecological reservation.",
      "poi_long_description": "Hikers say this hiking area offers a challenging workout with steep, paved trails and amazing views of the city, especially at sunset. They also highlight the convenience of the paved trail, making it accessible for all levels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-2325-7205-b306-cfca2d913002.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-2325-7205-b306-cfca2d913002",
        "storage_key": "property/6767906449166453/019d02cd-2325-7205-b306-cfca2d913002.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tumamoc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14370418977661907351&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tumamoc-hill-hiking-trail",
      "poi_latitude": "32.2260208",
      "poi_longitude": "-111.0010264",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-47b6-7079-84a5-e55e64fd5cb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-47b6-7079-84a5-e55e64fd5cb9",
        "storage_key": "property/6767906449166453/019d02cd-47b6-7079-84a5-e55e64fd5cb9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJp3AT_tJ21oYRl_ERJez7bcc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_54b5ea1b-9604-493b-bdf1-ef558743affa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Sweetwater Wetlands Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2511 W Sweetwater Dr, Tucson, AZ 85745, USA",
      "poi_short_description": "Lakeside sanctuary for migrating bird species such as ducks, hawks and coots, with paved trails, plus raccoons, turtles.",
      "poi_long_description": "People say this park offers excellent birding and wildlife viewing opportunities, with easy walking trails, benches, and ponds. They highlight the peaceful and tranquil atmosphere, and the well-maintained trails and facilities. They also like the informative signage and the availability of restrooms and drinking water.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-2378-7419-ae54-5414556e5a82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-2378-7419-ae54-5414556e5a82",
        "storage_key": "property/6767906449166453/019d02cd-2378-7419-ae54-5414556e5a82.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tucsonaz.gov/Departments/Water/Community-Relations/Sweetwater-Wetlands",
      "poi_directions_map_url": "https://maps.google.com/?cid=13437493023604516712&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sweetwater-wetlands-park",
      "poi_latitude": "32.2796666",
      "poi_longitude": "-111.0208989",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 520-791-4242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-47b6-7079-84a5-e55e64fd5cb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-47b6-7079-84a5-e55e64fd5cb9",
        "storage_key": "property/6767906449166453/019d02cd-47b6-7079-84a5-e55e64fd5cb9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJawH6lj901oYRaKe8x7WQe7o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1f6fac98-c56e-4ad1-857a-083955f6fcae",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Himmel Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1000 N Tucson Blvd, Tucson, AZ 85716, USA",
      "poi_short_description": "Popular playground area as well as a pool, library, baseball fields and tennis courts.",
      "poi_long_description": "People say this city park offers tennis and pickleball courts, basketball nets, baseball fields, picnic tables, and playgrounds with slides, swings, and climbing structures. They highlight the park's peaceful and wholesome vibe, and its suitability for contemplative walks, relaxing meditation, and people-watching. They also like the convenient parking, numerous trash bins, and dog-friendly environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-2612-72f8-8ec7-4c612416eff6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-2612-72f8-8ec7-4c612416eff6",
        "storage_key": "property/6767906449166453/019d02cd-2612-72f8-8ec7-4c612416eff6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tucsonaz.gov/Departments/Parks-and-Recreation/Parks/Himmel-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8985759539281181775&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "himmel-park",
      "poi_latitude": "32.2338763",
      "poi_longitude": "-110.9331501",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 520-791-4873",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-47b6-7079-84a5-e55e64fd5cb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-47b6-7079-84a5-e55e64fd5cb9",
        "storage_key": "property/6767906449166453/019d02cd-47b6-7079-84a5-e55e64fd5cb9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCflu87Nx1oYRT7zuP7HUs3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_75017c8c-68f0-4bff-820e-1e211e70a58b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Danny Lopez Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4300 N Silverbell Rd, Tucson, AZ 85745, USA",
      "poi_short_description": "Relaxing, clean park, with picnic tables, fishing and walking areas, plus a dog park.",
      "poi_long_description": "People say this city park offers a lake for fishing, walking trails, and a dog park. They also highlight the peaceful vibe and the presence of ducks.\n\nOther reviews mention the restrooms can be run down.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-2c94-7101-8236-8b8daa03f5e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-2c94-7101-8236-8b8daa03f5e6",
        "storage_key": "property/6767906449166453/019d02cd-2c94-7101-8236-8b8daa03f5e6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.tucsonaz.gov/Departments/Parks-and-Recreation/Parks/Christopher-Columbus-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14788660674142771250&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "danny-lopez-park",
      "poi_latitude": "32.285006",
      "poi_longitude": "-111.0367615",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 520-791-4873",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-47b6-7079-84a5-e55e64fd5cb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-47b6-7079-84a5-e55e64fd5cb9",
        "storage_key": "property/6767906449166453/019d02cd-47b6-7079-84a5-e55e64fd5cb9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMVo5ok901oYRMpgRiofgO80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_77ccc14c-5e09-4229-b528-0b364beee674",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Tucson Amtrak Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "400 N Toole Ave, Tucson, AZ 85701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-2eb5-77d9-83e9-27c855d48632.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-2eb5-77d9-83e9-27c855d48632",
        "storage_key": "property/6767906449166453/019d02cd-2eb5-77d9-83e9-27c855d48632.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=TUS",
      "poi_directions_map_url": "https://maps.google.com/?cid=1911839651037113618&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tucson-amtrak-station",
      "poi_latitude": "32.223297",
      "poi_longitude": "-110.966901",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-4801-70a8-895b-919b8527519e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-4801-70a8-895b-919b8527519e",
        "storage_key": "property/6767906449166453/019d02cd-4801-70a8-895b-919b8527519e.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJm6nzXOJw1oYREu2Sgwg4iBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_97961ded-a811-4152-a1c5-094f2c91928d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Tucson City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "255 W Alameda St, Tucson, AZ 85701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-2fde-75ee-8df3-5c750fc96407.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-2fde-75ee-8df3-5c750fc96407",
        "storage_key": "property/6767906449166453/019d02cd-2fde-75ee-8df3-5c750fc96407.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.tucsonaz.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10547674103679901385&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tucson-city-hall",
      "poi_latitude": "32.2226066",
      "poi_longitude": "-110.9747108",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 520-791-4213",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-4188-7766-900e-057d68b3022e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-4188-7766-900e-057d68b3022e",
        "storage_key": "property/6767906449166453/019d02cd-4188-7766-900e-057d68b3022e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWwQDvuNw1oYRyV5tnLbdYJI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_41b799d2-accd-4f80-b458-4d3b132c6cf2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "The Refinery at UA Tech Park at The Bridges",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 E Idea Ln, Tucson, AZ 85713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-3259-772c-819a-01732e3659ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-3259-772c-819a-01732e3659ae",
        "storage_key": "property/6767906449166453/019d02cd-3259-772c-819a-01732e3659ae.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://techparks.arizona.edu/ua-tech-park-at-the-bridges/the-refinery/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5466617039591032217&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-refinery-at-ua-tech-park-at-the-bridges",
      "poi_latitude": "32.1869631",
      "poi_longitude": "-110.9473007",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 520-621-4088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-41c1-7723-972a-2e31c5528a85",
        "storage_key": "property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyRCHwYVx1oYRmcXr7ztT3Us",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_eda69773-b67a-4a00-ba0d-e1e3d31c85dd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Hexagon - Mining division",
      "poi_type": "Major Employers & Offices",
      "poi_address": "40 E Congress St ste 150, Tucson, AZ 85701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-3392-708b-b1a9-2b32fedc0946.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-3392-708b-b1a9-2b32fedc0946",
        "storage_key": "property/6767906449166453/019d02cd-3392-708b-b1a9-2b32fedc0946.webp",
        "width": 950,
        "height": 640
      },
      "poi_business_url": "https://hexagon.com/company/divisions/mining",
      "poi_directions_map_url": "https://maps.google.com/?cid=10446549050850358282&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hexagon---mining-division",
      "poi_latitude": "32.2218278",
      "poi_longitude": "-110.9704085",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 520-795-3891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-41c1-7723-972a-2e31c5528a85",
        "storage_key": "property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN0dgw-9x1oYRCjSheAOZ-ZA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_32121399-b291-4593-a45a-e19b4a51aabf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Federal Court",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Congress St, Tucson, AZ 85701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-35c2-72ad-b6b1-78ded6aa001b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-35c2-72ad-b6b1-78ded6aa001b",
        "storage_key": "property/6767906449166453/019d02cd-35c2-72ad-b6b1-78ded6aa001b.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://www.azd.uscourts.gov/locations/tucson",
      "poi_directions_map_url": "https://maps.google.com/?cid=3982815530185395210&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "federal-court",
      "poi_latitude": "32.2205047",
      "poi_longitude": "-110.9763828",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 520-205-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-41c1-7723-972a-2e31c5528a85",
        "storage_key": "property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ52_XN9w1oYRCgyccp_NRTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f5ac52b3-94be-4ca5-b103-0905345d4598",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Climatec",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3895 N Business Center Dr #185, Tucson, AZ 85705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-36bd-75c3-9334-b38bd96c6872.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-36bd-75c3-9334-b38bd96c6872",
        "storage_key": "property/6767906449166453/019d02cd-36bd-75c3-9334-b38bd96c6872.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.climatec.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16911585383709674600&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "climatec",
      "poi_latitude": "32.2776612",
      "poi_longitude": "-111.0167363",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 520-571-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-41c1-7723-972a-2e31c5528a85",
        "storage_key": "property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZVKShhR01oYRaAy0GE4Fsuo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_efe681a5-d668-4be2-b9c6-47bd040edad1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Daisy Mae's Steak House",
      "poi_type": "Restaurants",
      "poi_address": "2735 W Anklam Rd, Tucson, AZ 85745, USA",
      "poi_short_description": "Rustic, Southwestern-style restaurant offering mesquite-fired steak, baby back ribs & more.",
      "poi_long_description": "People say this steakhouse serves delicious wings, ribs, and steaks, including T-bone and porterhouse. They also highlight the friendly staff, attentive service, and cozy, rustic atmosphere.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019eb35f-2d7f-7760-bd19-bced69f6f3f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb35f-2d7f-7760-bd19-bced69f6f3f3",
        "storage_key": "property/6767906449166453/019eb35f-2d7f-7760-bd19-bced69f6f3f3.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.daisymaessteakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8898254965416425112&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "daisy-maes-steak-house",
      "poi_latitude": "32.2245896",
      "poi_longitude": "-111.0253621",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-792-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-3ca8-7397-a6e2-538899e8a28c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-3ca8-7397-a6e2-538899e8a28c",
        "storage_key": "property/6767906449166453/019d02cd-3ca8-7397-a6e2-538899e8a28c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW36aKuZ21oYRmHaA_r7zfHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_1772bfd2-4ab1-4bbb-ba54-496b32a66946",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Signature Grill with Patio Dining",
      "poi_type": "Restaurants",
      "poi_address": "3800 W Starr Pass Blvd, Tucson, AZ 85745, USA",
      "poi_short_description": "Bright hotel dining room with a scenic patio featuring Native American & Mexican cooking traditions.",
      "poi_long_description": "Diners like this restaurant's delicious \"Tucson Style\" entrees, desserts, and breakfast options, including pancakes and a buffet. They also highlight the beautiful ambiance, great patio views, and friendly, accommodating staff.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019eb35f-2eb1-7262-9f73-7985f2d32022.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb35f-2eb1-7262-9f73-7985f2d32022",
        "storage_key": "property/6767906449166453/019eb35f-2eb1-7262-9f73-7985f2d32022.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.marriott.com/en-us/hotels/tussp-jw-marriott-tucson-starr-pass-resort-and-spa/dining/?scid=feed67b0-9a2f-4de1-8df6-114544116108",
      "poi_directions_map_url": "https://maps.google.com/?cid=2578799920169144384&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "signature-grill-with-patio-dining",
      "poi_latitude": "32.2158951",
      "poi_longitude": "-111.0501953",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-3ca8-7397-a6e2-538899e8a28c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-3ca8-7397-a6e2-538899e8a28c",
        "storage_key": "property/6767906449166453/019d02cd-3ca8-7397-a6e2-538899e8a28c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZSKejFZ21oYRQNB8RN28ySM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_c95dc4d8-db05-4aae-b71a-e893d5729fd0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Casa Madre Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "119 E 18th St, Tucson, AZ 85701, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this restaurant serves delicious ribeye, chile relleno, and a chef's board with a variety of flavors. They highlight the intimate and comfortable atmosphere, and the attentive and knowledgeable staff. They also like the house cocktails and appetizers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019eb35f-30c7-73b9-9a62-b4b3b1d2f306.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb35f-30c7-73b9-9a62-b4b3b1d2f306",
        "storage_key": "property/6767906449166453/019eb35f-30c7-73b9-9a62-b4b3b1d2f306.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://casamadretucson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2384945484381300114&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "casa-madre-restaurant",
      "poi_latitude": "32.2122052",
      "poi_longitude": "-110.9678622",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-526-2382",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-3ca8-7397-a6e2-538899e8a28c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-3ca8-7397-a6e2-538899e8a28c",
        "storage_key": "property/6767906449166453/019d02cd-3ca8-7397-a6e2-538899e8a28c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc5mhsilx1oYRkiU4NUgHGSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e361382b-c6c5-4746-943d-e510b1f06711",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Rusty's Family Restaurant & Sports Grille",
      "poi_type": "Restaurants",
      "poi_address": "2075 W Grant Rd, Tucson, AZ 85745, USA",
      "poi_short_description": "Spacious & lively, this sports pub offers Southwestern comfort fare & karaoke amid many TVs.",
      "poi_long_description": "People say this bar and grill serves delicious burgers, wings, and fries. They also highlight the fair food prices, the many TVs for watching sports, and the friendly service.\n\nOther reviews mention the drinks can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019eb35f-2f95-73eb-8665-db84852486b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb35f-2f95-73eb-8665-db84852486b3",
        "storage_key": "property/6767906449166453/019eb35f-2f95-73eb-8665-db84852486b3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rustys-family-restaurant.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11505272937633120836&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rustys-family-restaurant--sports-grille",
      "poi_latitude": "32.250372",
      "poi_longitude": "-111.0114579",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-623-3363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019eb35f-3660-77bd-a354-0aad518ef48f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eb35f-3660-77bd-a354-0aad518ef48f",
        "storage_key": "property/6767906449166453/019eb35f-3660-77bd-a354-0aad518ef48f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE7_lQ6V21oYRRIKJe8fwqp8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_d2268bf9-47e3-4cad-9bca-068ff57b3763",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "The District Bites and Brew",
      "poi_type": "Restaurants",
      "poi_address": "3025 N Campbell Ave #121, Tucson, AZ 85719, USA",
      "poi_short_description": "Friendly restaurant for burgers, wings, fried pickles and other eats.",
      "poi_long_description": "People say this restaurant serves delicious Asian salads, burgers, flatbreads, and fried pickles. They highlight the unique sauces, the fun and casual vibe, and the attentive staff. They also like the friendly service and the involved owners.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019eb35f-2d54-7451-82e8-e7a80acd3061.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb35f-2d54-7451-82e8-e7a80acd3061",
        "storage_key": "property/6767906449166453/019eb35f-2d54-7451-82e8-e7a80acd3061.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15968215035894237919&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-district-bites-and-brew",
      "poi_latitude": "32.261908",
      "poi_longitude": "-110.944485",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-710-9090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-3ca8-7397-a6e2-538899e8a28c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-3ca8-7397-a6e2-538899e8a28c",
        "storage_key": "property/6767906449166453/019d02cd-3ca8-7397-a6e2-538899e8a28c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk-keFQBx1oYR3wqHz_h-mt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_cb46ab56-4a27-4aae-a933-bbba4736cdee",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "St. Mary's Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "Tucson, AZ 85745, USA",
      "poi_short_description": "Shopping venue featuring a grocery for produce, meats and other items.",
      "poi_long_description": "Visitors say this shopping center offers a wide variety of stores, including a grocery store, laundromat, and auto services, making it practical for everyday needs. They also highlight the convenient access, ample parking, and friendly staff.\n\nSome reviews mention it can be uncomfortable due to panhandlers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019eb364-e423-772f-bf7f-3c6fe14c3349.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb364-e423-772f-bf7f-3c6fe14c3349",
        "storage_key": "property/6767906449166453/019eb364-e423-772f-bf7f-3c6fe14c3349.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8489321283315693156&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "st-marys-plaza",
      "poi_latitude": "32.2282929",
      "poi_longitude": "-110.9976277",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 323-965-1510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-3ca1-759d-bd94-a1ef45a16986.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-3ca1-759d-bd94-a1ef45a16986",
        "storage_key": "property/6767906449166453/019d02cd-3ca1-759d-bd94-a1ef45a16986.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHdAKpm9x1oYRZPYxlLog0HU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_862742e2-4cfd-42c7-b59c-5de86a64ed78",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Tucson Spectrum",
      "poi_type": "Shopping & Retail",
      "poi_address": "1251 W Irvington Rd, Tucson, AZ 85714, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this shopping center offers a great variety of stores and everything needed in one large place. Visitors also highlight the comfortable seating in the handicap section and the ample parking. They also mention the good treatment from staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019eb364-e38f-7049-ab24-5768fb4b4e74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb364-e38f-7049-ab24-5768fb4b4e74",
        "storage_key": "property/6767906449166453/019eb364-e38f-7049-ab24-5768fb4b4e74.webp",
        "width": 414,
        "height": 414
      },
      "poi_business_url": "https://www.tucsonspectrum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8431538858037099537&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tucson-spectrum",
      "poi_latitude": "32.157793",
      "poi_longitude": "-110.9882906",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-531-6234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-3ca1-759d-bd94-a1ef45a16986.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-3ca1-759d-bd94-a1ef45a16986",
        "storage_key": "property/6767906449166453/019d02cd-3ca1-759d-bd94-a1ef45a16986.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJmyLzeAB71oYRETw0T-vXAnU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f60d5826-49a9-4886-b6b4-31d492e9165b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Ace Hardware",
      "poi_type": "Shopping & Retail",
      "poi_address": "4640 E Broadway Blvd, Tucson, AZ 85711, USA",
      "poi_short_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_long_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019eb364-e3f1-75e9-8cba-9db5843c9b50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb364-e3f1-75e9-8cba-9db5843c9b50",
        "storage_key": "property/6767906449166453/019eb364-e3f1-75e9-8cba-9db5843c9b50.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.acehardware.com/store-details/17777",
      "poi_directions_map_url": "https://maps.google.com/?cid=12661308365761681718&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ace-hardware",
      "poi_latitude": "32.2210067",
      "poi_longitude": "-110.8932638",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-318-0414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-3ca1-759d-bd94-a1ef45a16986.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-3ca1-759d-bd94-a1ef45a16986",
        "storage_key": "property/6767906449166453/019d02cd-3ca1-759d-bd94-a1ef45a16986.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJx3_c_K9v1oYRNhnoTOAAtq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hardware_store"
    },
    {
      "id": "custom_5426a790-739a-42ec-ad15-2edbd0ac61f9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "3000 E 22nd St, Tucson, AZ 85713, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019eb364-e64b-7123-b2ee-aaec15ea871d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb364-e64b-7123-b2ee-aaec15ea871d",
        "storage_key": "property/6767906449166453/019eb364-e64b-7123-b2ee-aaec15ea871d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.familydollar.com/locations/az/tucson/33846/",
      "poi_directions_map_url": "https://maps.google.com/?cid=511511411794260565&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "32.2064386",
      "poi_longitude": "-110.9281299",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-365-2132",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-3ca1-759d-bd94-a1ef45a16986.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-3ca1-759d-bd94-a1ef45a16986",
        "storage_key": "property/6767906449166453/019d02cd-3ca1-759d-bd94-a1ef45a16986.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAwJvEJZx1oYRVTKOPutAGQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_d7108f49-77a1-48ae-a4e2-242a64ddd386",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Harkins Theatres Tucson Spectrum",
      "poi_type": "Entertainment",
      "poi_address": "Spectrum, 5455 S Calle Santa Cruz, Tucson, AZ 85706, USA",
      "poi_short_description": "Modern cinema showing first-run films on 18 screens, with a snack bar & lobby play area.",
      "poi_long_description": "People say this movie theater offers fresh popcorn and a great selection of movies. They highlight the comfortable seats, clean facilities, and friendly staff. They also like the spacious seating with ample legroom.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019eb368-7656-72e5-8bb4-44da3d377aee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb368-7656-72e5-8bb4-44da3d377aee",
        "storage_key": "property/6767906449166453/019eb368-7656-72e5-8bb4-44da3d377aee.webp",
        "width": 1280,
        "height": 1006
      },
      "poi_business_url": "https://harkins.com/theatres/tucson-spectrum?utm_source=google_listing&utm_medium=web&utm_campaign=gmb&utm_id=local_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13446362087115569168&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "harkins-theatres-tucson-spectrum",
      "poi_latitude": "32.1520638",
      "poi_longitude": "-110.9879709",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-889-5588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019eb368-7df9-711d-8e33-051919859a8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eb368-7df9-711d-8e33-051919859a8f",
        "storage_key": "property/6767906449166453/019eb368-7df9-711d-8e33-051919859a8f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJr-uUNyJ61oYRELjNixMTm7o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_3781ef47-0291-4479-a0fa-5fa04d40aa0d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Fox Tucson Theatre",
      "poi_type": "Entertainment",
      "poi_address": "17 W Congress St, Tucson, AZ 85701, USA",
      "poi_short_description": "Performance venue for live music, revues, theater & more housed in a historic 1930s-era building.",
      "poi_long_description": "People say this theater is a beautiful, historic, and well-maintained venue that offers a wide variety of shows and concerts with fantastic acoustics. Visitors also highlight the intimate atmosphere, comfortable seating with great views, and the helpful, friendly staff. They also mention the venue is clean and offers convenient parking options nearby.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019eb368-765f-7210-9c23-ccbc71c35d64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb368-765f-7210-9c23-ccbc71c35d64",
        "storage_key": "property/6767906449166453/019eb368-765f-7210-9c23-ccbc71c35d64.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://www.foxtucson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2923890842481475391&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fox-tucson-theatre",
      "poi_latitude": "32.2220224",
      "poi_longitude": "-110.9716152",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-547-3040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-41c1-7723-972a-2e31c5528a85",
        "storage_key": "property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ20cDLuBw1oYRPz8g1Dq_kyg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_a22b7d0b-ddc3-468d-b462-844d6d7de6fe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Tumamoc Hill",
      "poi_type": "Entertainment",
      "poi_address": "Tumamoc Hill Rd, Tucson, AZ 85745, USA",
      "poi_short_description": "University run protected area of Sonoran Desert with over a 100 years of intensive science.",
      "poi_long_description": "People say this hiking trail offers breathtaking views of the city, especially at sunset and night, and provides a challenging yet rewarding workout. Visitors also highlight the paved path, making it suitable for all ages and fitness levels, and appreciate the free and easy street parking. They also mention the peaceful atmosphere and friendly people.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019eb368-774f-74e5-ae33-4d88cef3238a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb368-774f-74e5-ae33-4d88cef3238a",
        "storage_key": "property/6767906449166453/019eb368-774f-74e5-ae33-4d88cef3238a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://tumamoc.arizona.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17563454997320670576&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tumamoc-hill",
      "poi_latitude": "32.2254619",
      "poi_longitude": "-111.0016214",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-47b6-7079-84a5-e55e64fd5cb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-47b6-7079-84a5-e55e64fd5cb9",
        "storage_key": "property/6767906449166453/019d02cd-47b6-7079-84a5-e55e64fd5cb9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZaL4PSl31oYRcJ3bz0PtvfM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_a903e424-2d4f-4729-8f62-73f24b796d92",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Salud",
      "poi_type": "Restaurants",
      "poi_address": "3800 W Starr Pass Blvd, Tucson, AZ 85745, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019eb3a8-a02c-749c-9653-cb00e3f66395.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb3a8-a02c-749c-9653-cb00e3f66395",
        "storage_key": "property/6767906449166453/019eb3a8-a02c-749c-9653-cb00e3f66395.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.marriott.com/en-us/hotels/tussp-jw-marriott-tucson-starr-pass-resort-and-spa/dining/?scid=feed67b0-9a2f-4de1-8df6-114544116108",
      "poi_directions_map_url": "https://maps.google.com/?cid=9074399972163055013&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "salud",
      "poi_latitude": "32.2159294",
      "poi_longitude": "-111.0501752",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-791-6015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-3ca8-7397-a6e2-538899e8a28c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-3ca8-7397-a6e2-538899e8a28c",
        "storage_key": "property/6767906449166453/019d02cd-3ca8-7397-a6e2-538899e8a28c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZSKejFZ21oYRpe2XSrK-7n0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7c36b852-5564-4a1c-8c05-4a0313a205d6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Mercado San Agustín",
      "poi_type": "Shopping & Retail",
      "poi_address": "100 South Avenida del Convento, Tucson, AZ 85745, USA",
      "poi_short_description": "Charming market with eateries & shops surrounding a courtyard that hosts a farmers' market & events.",
      "poi_long_description": "People say this market offers delicious coffee, donuts, tamales, and tacos, as well as upscale steak. They highlight the trendy, hip, and romantic vibe, and the beautiful ambiance with a huge patio. They also like the array of specialty shops and restaurants, and the easy access to the area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019eb423-0647-73c9-a63e-7a99770c8f5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb423-0647-73c9-a63e-7a99770c8f5a",
        "storage_key": "property/6767906449166453/019eb423-0647-73c9-a63e-7a99770c8f5a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://mercadodistrict.com/mercado/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4663885071845376031&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mercado-san-agustn",
      "poi_latitude": "32.2201355",
      "poi_longitude": "-110.9856285",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-461-1107",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-3ca1-759d-bd94-a1ef45a16986.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-3ca1-759d-bd94-a1ef45a16986",
        "storage_key": "property/6767906449166453/019d02cd-3ca1-759d-bd94-a1ef45a16986.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVVVVVTlu1oYRH0CXNMNyuUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "market"
    },
    {
      "id": "custom_cb5329d8-af8a-450e-b146-4504efd5f640",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Cholla High School",
      "poi_type": "Education",
      "poi_address": "2001 W Starr Pass Blvd, Tucson, AZ 85713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f0140-bfbd-76ef-a632-0f17cdd5b185.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0140-bfbd-76ef-a632-0f17cdd5b185",
        "storage_key": "property/6767906449166453/019f0140-bfbd-76ef-a632-0f17cdd5b185.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chollahs.tusd1.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11361529464042902640&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cholla-high-school",
      "poi_latitude": "32.2064143",
      "poi_longitude": "-111.0104286",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-225-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-3ccf-724a-8ab4-fc8e6c26fc7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-3ccf-724a-8ab4-fc8e6c26fc7a",
        "storage_key": "property/6767906449166453/019d02cd-3ccf-724a-8ab4-fc8e6c26fc7a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmz2m6y931oYRcFRpAdpCrJ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_316edf2d-9c2e-4446-aa40-f3a86401059f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Joaquin Murrieta Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1400 N Silverbell Rd, Tucson, AZ 85745, USA",
      "poi_short_description": "Neighborhood park featuring athletic fields, a playground, and wildlife.",
      "poi_long_description": "Visitors say this park features a fantastic splash pad, a cute playground, and well-maintained baseball and softball fields. They also highlight the clean restrooms, spacious ramadas with grills, and the overall family-friendly atmosphere.\n\nSome reviews mention the bathrooms can be neglected.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f0140-bb59-728c-a063-f9a69ffbcda2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0140-bb59-728c-a063-f9a69ffbcda2",
        "storage_key": "property/6767906449166453/019f0140-bb59-728c-a063-f9a69ffbcda2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.tucsonaz.gov/Departments/Parks-and-Recreation/Parks/Joaquin-Murrieta-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=199903123840592574&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "joaquin-murrieta-park",
      "poi_latitude": "32.2417431",
      "poi_longitude": "-111.0050687",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-791-4873",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-47b6-7079-84a5-e55e64fd5cb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-47b6-7079-84a5-e55e64fd5cb9",
        "storage_key": "property/6767906449166453/019d02cd-47b6-7079-84a5-e55e64fd5cb9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJV9yNiLZ21oYRvmoC_tQyxgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_bcd49b1e-82f8-481b-b353-565752fb912c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "John F. Kennedy Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3700 S Mission Rd, Tucson, AZ 85713, USA",
      "poi_short_description": "Green space with playgrounds, trails & multi-use fields, plus shaded picnic tables & a fishing lake.",
      "poi_long_description": "People say this park offers a nice lake for fishing and walking, along with a playground and ramadas for gatherings. Visitors also highlight the clean environment and picnic areas with barbecue facilities.\n\nSome reviews mention the park can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f0140-c215-728c-a1c0-b4af53a32d86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0140-c215-728c-a1c0-b4af53a32d86",
        "storage_key": "property/6767906449166453/019f0140-c215-728c-a1c0-b4af53a32d86.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tucsonaz.gov/Departments/Parks-and-Recreation/Parks/John-F-Kennedy-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=18298969554704457105&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "john-f-kennedy-park",
      "poi_latitude": "32.1797635",
      "poi_longitude": "-111.0035667",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-791-4873",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-47b6-7079-84a5-e55e64fd5cb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-47b6-7079-84a5-e55e64fd5cb9",
        "storage_key": "property/6767906449166453/019d02cd-47b6-7079-84a5-e55e64fd5cb9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJp05Ht1p31oYRkd3Yn9v_8v0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_9a73f0ed-b33b-4bc6-a20e-1207cf950341",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Downtown Ronstadt Center (B)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tucson, AZ 85701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f0140-ba57-7238-af73-4e90d9f9b6ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0140-ba57-7238-af73-4e90d9f9b6ff",
        "storage_key": "property/6767906449166453/019f0140-ba57-7238-af73-4e90d9f9b6ff.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9632664471308726802&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "downtown-ronstadt-center-b",
      "poi_latitude": "32.223083",
      "poi_longitude": "-110.968123",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-41c1-7723-972a-2e31c5528a85",
        "storage_key": "property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc8dFBOJw1oYREvLh9EwZroU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_06b2526e-9ba2-4e4e-99c4-8444b4bfdd0c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "SL/Cushing/Frontage Rd",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tucson, AZ 85745, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f0140-bede-725e-8ebf-f3cc4269f9b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0140-bede-725e-8ebf-f3cc4269f9b3",
        "storage_key": "property/6767906449166453/019f0140-bede-725e-8ebf-f3cc4269f9b3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16487335319300970544&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "slcushingfrontage-rd",
      "poi_latitude": "32.217174",
      "poi_longitude": "-110.980513",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-41c1-7723-972a-2e31c5528a85",
        "storage_key": "property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAd7gst5w1oYRMJivhx7IzuQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_3ee72b21-0786-474b-81c5-678bf5b446e5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Plaza Centro",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tucson, AZ 85705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f0140-baf9-71e1-8576-1099e3ff4dbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0140-baf9-71e1-8576-1099e3ff4dbf",
        "storage_key": "property/6767906449166453/019f0140-baf9-71e1-8576-1099e3ff4dbf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12280872802785828715&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "plaza-centro",
      "poi_latitude": "32.22175500000001",
      "poi_longitude": "-110.965539",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-41c1-7723-972a-2e31c5528a85",
        "storage_key": "property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBXJmWeJw1oYRax_OTb9sbqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_9d069065-cc76-412d-8455-14ea9ee33be8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Tucson International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7250 S Tucson Blvd, Tucson, AZ 85756, USA",
      "poi_short_description": "Airport serving southern Arizona & featuring free WiFi plus exhibits by regional artists.",
      "poi_long_description": "People say this airport is small, easy to navigate, and offers quick security lines. They also highlight the clean facilities, helpful staff, and convenient parking options, including a cell phone waiting lot. Visitors appreciate the relaxed atmosphere and efficient experience, making it a stress-free choice for travel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f0140-b71d-74cc-b960-123d7bd5844f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0140-b71d-74cc-b960-123d7bd5844f",
        "storage_key": "property/6767906449166453/019f0140-b71d-74cc-b960-123d7bd5844f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.flytucson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12911939063544620565&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tucson-international-airport",
      "poi_latitude": "32.1145102",
      "poi_longitude": "-110.9392269",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-573-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f0140-caf8-7482-a8d7-ac54f9cec4e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f0140-caf8-7482-a8d7-ac54f9cec4e1",
        "storage_key": "property/6767906449166453/019f0140-caf8-7482-a8d7-ac54f9cec4e1.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJt9XQCBN71oYRFSYR_CpsMLM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_cac41349-ff53-4f63-b12f-26afaf776271",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Tohono Tadai Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4540 N Stone Ave, Tucson, AZ 85705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f0140-ba56-77a8-9a43-d855f7514135.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0140-ba56-77a8-9a43-d855f7514135",
        "storage_key": "property/6767906449166453/019f0140-ba56-77a8-9a43-d855f7514135.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13459878601544907913&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tohono-tadai-transit-center",
      "poi_latitude": "32.2889175",
      "poi_longitude": "-110.9693953",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f0140-caf8-7482-a8d7-a803dc2117cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f0140-caf8-7482-a8d7-a803dc2117cc",
        "storage_key": "property/6767906449166453/019f0140-caf8-7482-a8d7-a803dc2117cc.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJh80iW79z1oYRiTz3TEYYy7o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_e6aaa5b6-4851-4105-82ed-2717e1668a04",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Caterpillar Tucson Mining Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "875 W Cushing St, Tucson, AZ 85745, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f0140-c523-738c-af81-daf26db84905.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0140-c523-738c-af81-daf26db84905",
        "storage_key": "property/6767906449166453/019f0140-c523-738c-af81-daf26db84905.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.caterpillar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=506503965440404125&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "caterpillar-tucson-mining-center",
      "poi_latitude": "32.2172688",
      "poi_longitude": "-110.9841124",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-917-8587",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-41c1-7723-972a-2e31c5528a85",
        "storage_key": "property/6767906449166453/019d02cd-41c1-7723-972a-2e31c5528a85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlWdutWBx1oYRnepmSax2Bwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d7c9cff6-36b8-418b-9e78-4cdfbdcf3b05",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Morgan Maxwell K-8 School",
      "poi_type": "Education",
      "poi_address": "2802 W Anklam Rd, Tucson, AZ 85745, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://tusd1.org/maxwell/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3466395129054131405&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "morgan-maxwell-k-8-school",
      "poi_latitude": "32.2254472",
      "poi_longitude": "-111.0283179",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 520-225-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-3ccf-724a-8ab4-fc8e6c26fc7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-3ccf-724a-8ab4-fc8e6c26fc7a",
        "storage_key": "property/6767906449166453/019d02cd-3ccf-724a-8ab4-fc8e6c26fc7a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzbQgwuh21oYRzXRqDgEcGzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_509a2c6d-8d76-493d-9156-32f0c4caeaec",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "The Apple Tree Learning Centers",
      "poi_type": "Education",
      "poi_address": "1010 E Broadway Blvd, Tucson, AZ 85719, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f0613-75a1-7491-9d76-df2a0ffb60ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0613-75a1-7491-9d76-df2a0ffb60ae",
        "storage_key": "property/6767906449166453/019f0613-75a1-7491-9d76-df2a0ffb60ae.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.theappletreelearningcenters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10131828028854175192&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-apple-tree-learning-centers",
      "poi_latitude": "32.2210768",
      "poi_longitude": "-110.9560334",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 520-882-3816",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-3ccf-724a-8ab4-fc8e6c26fc7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-3ccf-724a-8ab4-fc8e6c26fc7a",
        "storage_key": "property/6767906449166453/019d02cd-3ccf-724a-8ab4-fc8e6c26fc7a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyYJ7o_5w1oYR2AUzWel7m4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_762ec84a-b595-4f68-9676-4ee76577570c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "poi_name": "Mission Garden",
      "poi_type": "Entertainment",
      "poi_address": "946 W Mission Ln, Tucson, AZ 85745, USA",
      "poi_short_description": "Historical site showcasing the region's agricultural heritage with various garden plots.",
      "poi_long_description": "Visitors say this garden offers a beautiful setting with historical crops, native plants, and fruit trees, providing a wonderful learning experience for all ages. They also highlight the free admission and the fantastic gift shop with products made from garden produce. Guests mention the knowledgeable staff and the tranquil, peaceful atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f0613-7608-7605-92d8-4c91f243d5f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0613-7608-7605-92d8-4c91f243d5f9",
        "storage_key": "property/6767906449166453/019f0613-7608-7605-92d8-4c91f243d5f9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.missiongarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17749905960767100993&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mission-garden",
      "poi_latitude": "32.2142412",
      "poi_longitude": "-110.9860719",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 520-955-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cd-41d7-768e-b0dc-08faf0c0287b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-41d7-768e-b0dc-08faf0c0287b",
        "storage_key": "property/6767906449166453/019d02cd-41d7-768e-b0dc-08faf0c0287b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJh-WYotBw1oYRQZgcpG1VVPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    }
  ],
  "office_hours": [
    {
      "id": "ec_51f660763db7d3813b5bba10",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_259a65601a9df71481a31916",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_dc903b38df2e000a2081035a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_d2b9afb27b78644941a3d5ef",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_649c38f4130823434287000a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_05a8ba0c1f91a234ce48e790",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_8cbd0ca3-3e09-41e3-b97d-0885abe638e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "rating": "5.0",
      "name": "Paul Silva",
      "text": "I LOVE these apartments and the staff here!!!\nThe views are also amazing if you love watching the sun rise or set behind a mountain ( WHO DOESN'T!!!)\nAgain, the staff has always helped me with anything I need and kept a smile.\nThey also throw AMAZING pool parties for the residents that make you feel like your home with family for a BBQ.",
      "date": "2025-09-06",
      "title": ""
    },
    {
      "id": "custom_f4cc5a82-4b02-4cfd-94e1-e03cb7e03758",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "rating": "5.0",
      "name": "Dune Dulay",
      "text": "Love the apartment size and amenities that it comes with. I enjoy the pool with the grill at night. Love having barbecues and making food there. The club house is a plus with games and a kitchen for a get together.",
      "date": "2025-08-13",
      "title": ""
    },
    {
      "id": "custom_f73f2108-574b-4871-88a0-7b5ab1ad3b42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "rating": "5.0",
      "name": "TJ",
      "text": "Absolutely lovely community with a fantastic location tucked away from the city. Beautiful desert landscapes and great amenities.  The pool is accessible and clean. The property management team is friendly, responsive and professional.  Shirley has been an absolute pleasure to work with. I highly recommend this community to anybody looking for a great place to live.",
      "date": "2025-08-27",
      "title": ""
    },
    {
      "id": "custom_48f6fad6-df33-4f08-abfe-402843d1353f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "rating": "5.0",
      "name": "Jacob Litt",
      "text": "We have lived here for a little over a year and have thoroughly appreciated what Sonoran Reserve provides us. Our unit is a nice size and quality, the location is peaceful, the communal resources like the pool and gym are great, and I have to give a special shout-out to the maintenance staff: every time I have submitted a maintenance request, it has been taken care of within a few days, and usually the very next day! They've got a great team!",
      "date": "2025-08-20",
      "title": ""
    },
    {
      "id": "custom_db6a54e7-6fde-4da7-9f02-b22a19f96157",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "rating": "5.0",
      "name": "Junior Toscano",
      "text": "I had an amazing experience during my visit to this apartment complex! From the moment I arrived, Shirley’s staff was incredibly professional, friendly, and welcoming—they truly made me feel at home. The property itself is just as impressive: clean, well-maintained, and beautifully designed. Everything exceeded my expectations. I'm genuinely looking forward to calling this place home. Highly recommended!",
      "date": "2025-08-09",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_463b7731-e3c6-4a7a-bb67-896d597607ac",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f6c18-f413-70b2-ba3d-bdc5028b7fdd.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-f413-70b2-ba3d-bdc5028b7fdd",
        "storage_key": "property/6767906449166453/019f6c18-f413-70b2-ba3d-bdc5028b7fdd.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Apartment Tour | 1 BR, 1 BA | 457 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ogA1GvQSuWK"
    },
    {
      "id": "custom_fba96729-48ba-419a-9f6d-27ae0b212cac",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f6c18-f438-71cc-ab27-2e6f5b861123.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-f438-71cc-ab27-2e6f5b861123",
        "storage_key": "property/6767906449166453/019f6c18-f438-71cc-ab27-2e6f5b861123.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 1 BR, 1 BA | 554 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ThsPjk64yDE"
    },
    {
      "id": "custom_f700a154-8003-4af7-ad0d-878a2463d696",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f6c18-f438-71cc-ab27-2b4b5932e3da.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-f438-71cc-ab27-2b4b5932e3da",
        "storage_key": "property/6767906449166453/019f6c18-f438-71cc-ab27-2b4b5932e3da.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA | 825 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=qJP1qdkJcQd"
    },
    {
      "id": "custom_38d35240-3b0c-4669-aae7-a611c1841e08",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f6c18-f448-728e-89be-a4b3808e4f96.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-f448-728e-89be-a4b3808e4f96",
        "storage_key": "property/6767906449166453/019f6c18-f448-728e-89be-a4b3808e4f96.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Apartment Tour | 3 BR, 3 BA | 1039 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kdorURCa5mm"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199e008-14e6-762c-b823-d26317fb8bc8",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-sonoran-reserve-auto",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "generator",
      "page_item_url": "pool-apartments-tucson-az",
      "search_query": "apartments with pool Tucson AZ",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Tucson, AZ",
      "h2_subtitle": "Discover charming apartments with pool access in Tucson, AZ! Experience the relaxing lifestyle at Sonoran Reserve today.",
      "page_copy": "Welcome to Sonoran Reserve, where living in elegance and comfort is within reach. Located in the vibrant city of Tucson, AZ, our apartments are thoughtfully designed with residents in mind. Featuring a sparkling pool, the perfect retreat for relaxation under the sun, this community is tailored for those who appreciate style and leisure. Whether you're lounging poolside or enjoying a swim, serenity is just steps from your door.\n\nChoose from a variety of spacious one to four-bedroom floor plans that match your lifestyle. Bask in the modern amenities and inviting atmosphere of Sonoran Reserve. Beyond the pool, residents enjoy access to a state-of-the-art fitness center, perfect for maintaining an active lifestyle, and a welcoming clubhouse for social gatherings. Discover a community where you can relax and rejuvenate – make this vibrant oasis in Tucson, AZ, your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
      "featured_image_media": {
        "alt_text": "Sonoran Reserve leasing office reception desk with yellow chairs and modern lighting.",
        "public_id": "019d02cc-840d-75cf-9253-1b13a322822e",
        "storage_key": "property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Tucson, AZ",
      "seo_description": "Explore Sonoran Reserve, Tucson, AZ's premier apartment community featuring a sparkling pool and spacious floor plans designed for modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-haven-ridge",
      "search_query": "fitness center apartments Haven Ridge",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Haven Ridge",
      "h2_subtitle": "Discover premium fitness center apartments in Haven Ridge! Sonoran Reserve offers state-of-the-art fitness amenities.",
      "page_copy": "Nestled in the charming neighborhood of Haven Ridge, Sonoran Reserve offers the perfect combination of fitness and comfort. Our apartments come equipped with a state-of-the-art fitness center, providing residents with everything needed to maintain an active lifestyle without leaving home. Offering a range of equipment suitable for all workout preferences, the fitness center is designed to accommodate the needs of both beginners and fitness enthusiasts alike.\n\nIn addition to our exceptional fitness amenities, Sonoran Reserve boasts a selection of spacious one to four-bedroom apartments, crafted for modern living. Experience unparalleled convenience with on-site amenities, including a sparkling pool, inviting clubhouse, and pet-friendly spaces like our dog park. Located in Tucson's desirable Haven Ridge community, your new home awaits at Sonoran Reserve.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
      "featured_image_media": {
        "alt_text": "Sonoran Reserve leasing office reception desk with yellow chairs and modern lighting.",
        "public_id": "019d02cc-840d-75cf-9253-1b13a322822e",
        "storage_key": "property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Haven Ridge",
      "seo_description": "Live at Sonoran Reserve in Haven Ridge, Tucson, where our fitness center and modern apartments create the perfect home environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "generator",
      "page_item_url": "gated-community-apartments-pima-county",
      "search_query": "gated community apartments Pima County",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments in Pima County",
      "h2_subtitle": "Explore gated community apartments in Pima County. Sonoran Reserve offers security and comfort in Tucson’s vibrant neighborhood.",
      "page_copy": "Discover Sonoran Reserve, a premier gated community offering an enhanced living experience in Pima County, Tucson. Our apartments provide residents with added security and peace of mind, creating a tranquil oasis amidst the bustling city. Choose from a diverse selection of one to four-bedroom floor plans, thoughtfully designed to cater to various lifestyles without compromising on comfort and style.\n\nAt Sonoran Reserve, residents enjoy resort-style amenities such as a sparkling pool and a modern fitness center, perfect for relaxation and exercise. Our pet-friendly community welcomes furry friends, providing a dedicated dog park for play and socialization. Situated in a desirable location, experience both privacy and convenience living in this exceptional gated community – the ideal place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
      "featured_image_media": {
        "alt_text": "Sonoran Reserve leasing office reception desk with yellow chairs and modern lighting.",
        "public_id": "019d02cc-840d-75cf-9253-1b13a322822e",
        "storage_key": "property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apartments, Pima County",
      "seo_description": "Experience secure living at Sonoran Reserve, Tucson’s top gated community in Pima County, offering diverse floor plans and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "generator",
      "page_item_url": "dog-park-apartments-near-85745",
      "search_query": "dog park apartments near 85745",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments Near 85745",
      "h2_subtitle": "Find dog park apartments near 85745! Sonoran Reserve offers pet-friendly living with a dedicated dog park in Tucson, AZ.",
      "page_copy": "Welcome to Sonoran Reserve, where furry family members are as welcome as their human counterparts. Located near the 85745 area of Tucson, AZ, our pet-friendly community is perfect for dog lovers. Featuring a spacious dog park, this community is designed to accommodate the needs of your pets, providing a safe and fun environment for them to play and socialize.\n\nBeyond the dog park, Sonoran Reserve offers a variety of modern amenities to elevate your living experience. Choose from thoughtfully designed one to four-bedroom apartments that blend comfort with style. Enjoy exclusive access to a sparkling pool, a state-of-the-art fitness center, and a welcoming clubhouse. Situated in a prime Tucson location, Sonoran Reserve is the ideal destination for pet owners and those who appreciate a vibrant, community-oriented lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
      "featured_image_media": {
        "alt_text": "Sonoran Reserve leasing office reception desk with yellow chairs and modern lighting.",
        "public_id": "019d02cc-840d-75cf-9253-1b13a322822e",
        "storage_key": "property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments Near 85745",
      "seo_description": "Sonoran Reserve offers pet-friendly apartments with a dog park near 85745 in Tucson, AZ. Explore modern living and amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "generator",
      "page_item_url": "luxury-clubhouse-apartments-tucson",
      "search_query": "luxury clubhouse apartments Tucson",
      "category": "Amenity",
      "h1_title": "Luxury Clubhouse Apartments in Tucson",
      "h2_subtitle": "Explore luxury clubhouse apartments in Tucson. Sonoran Reserve offers exceptional amenities including a stylish clubhouse.",
      "page_copy": "Experience high-end living at Sonoran Reserve, Tucson's premier destination for luxury clubhouse apartments. Our community is designed for those who appreciate both style and substance, offering a range of amenities that exemplify upscale living. The clubhouse serves as a social hub, providing a sophisticated space for gatherings, relaxation, or community events.\n\nAt Sonoran Reserve, luxurious living extends beyond our elegant clubhouse. Choose from a selection of one to four-bedroom floor plans that embody modern comfort and spaciousness. Additionally, residents can enjoy resort-style amenities such as a sparkling pool, state-of-the-art fitness center, and a dog park perfect for pet enthusiasts. Nestled in the heart of Tucson, Sonoran Reserve is the ultimate place to enjoy a vibrant lifestyle matched with lavish amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
      "featured_image_media": {
        "alt_text": "Sonoran Reserve leasing office reception desk with yellow chairs and modern lighting.",
        "public_id": "019d02cc-840d-75cf-9253-1b13a322822e",
        "storage_key": "property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Clubhouse Apartments, Tucson",
      "seo_description": "Discover Sonoran Reserve’s luxury clubhouse apartments in Tucson, offering a stylish clubhouse and premium amenities for refined living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-tucson-az",
      "search_query": "1 bedroom apartments tucson az",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Tucson, AZ",
      "h2_subtitle": "Discover 1 bedroom apartments in Tucson, AZ. Sonoran Reserve offers modern floor plans with premier amenities and style.",
      "page_copy": "Welcome to Sonoran Reserve, the ideal choice for those seeking 1 bedroom apartments in Tucson, AZ. Our community offers thoughtfully designed spaces that cater to individuals or couples who value comfort and convenience. Each apartment is crafted to maximize living area, featuring modern interiors and finishes that create a welcoming home environment.\n\nBeyond the walls of your stylish apartment, Sonoran Reserve provides a wealth of amenities. Enjoy unwinding by the sparkling pool, maintaining your fitness goals in the state-of-the-art fitness center, or simply relaxing in our luxury clubhouse. Situated at the heart of Tucson, our community offers easy access to vibrant city life while providing a relaxing retreat at home. Experience the perfect blend of luxury and practicality at Sonoran Reserve.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
      "featured_image_media": {
        "alt_text": "Sonoran Reserve leasing office reception desk with yellow chairs and modern lighting.",
        "public_id": "019d02cc-840d-75cf-9253-1b13a322822e",
        "storage_key": "property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Tucson, AZ",
      "seo_description": "Explore stylish 1 bedroom apartments in Tucson, AZ at Sonoran Reserve, featuring modern amenities and inviting community spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-haven-ridge",
      "search_query": "2 bedroom apartments haven ridge",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Haven Ridge",
      "h2_subtitle": "Discover 2 bedroom apartments in Haven Ridge. Sonoran Reserve offers spacious floor plans with top-notch amenities.",
      "page_copy": "Situated in the inviting neighborhood of Haven Ridge, Sonoran Reserve offers exceptional 2 bedroom apartments perfect for those seeking ample space and modern design. Our thoughtfully planned layouts provide the perfect balance of comfort and functionality, making them ideal for families, roommates, or individuals who desire extra space.\n\nAt Sonoran Reserve, residents can relish in an array of premium amenities. Enjoy sunny days by the glistening pool, get energized in our fully equipped fitness center, or meet up with friends in our welcoming clubhouse. Plus, our dedicated dog park ensures that even your pets have a place to thrive. Located in the heart of Haven Ridge, Sonoran Reserve blends luxurious living with convenience, offering everything you need right at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
      "featured_image_media": {
        "alt_text": "Sonoran Reserve leasing office reception desk with yellow chairs and modern lighting.",
        "public_id": "019d02cc-840d-75cf-9253-1b13a322822e",
        "storage_key": "property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Haven Ridge",
      "seo_description": "Find spacious 2 bedroom apartments in Haven Ridge at Sonoran Reserve, offering modern amenities and a vibrant community feel.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-near-85745",
      "search_query": "3 bedroom apartments near 85745",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near 85745",
      "h2_subtitle": "Explore spacious 3 bedroom apartments near 85745. Sonoran Reserve offers family-friendly layouts and exciting amenities.",
      "page_copy": "Discover the perfect home at Sonoran Reserve, where our 3 bedroom apartments near the 85745 area offer ample space and comfort for families and roommates alike. Each apartment is designed with modern living in mind, combining style and functionality with generous living areas and contemporary finishes that cater to your everyday needs.\n\nEnjoy more than just your apartment at Sonoran Reserve. Our community features a wide variety of amenities, including a sparkling pool that's perfect for cooling off, a state-of-the-art fitness center to maintain your active lifestyle, and a welcoming clubhouse for socializing. Ideally positioned near the 85745 ZIP code, Sonoran Reserve offers the convenience of city living while providing a tranquil retreat within the community. Experience the best of Tucson living with our 3 bedroom offerings.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
      "featured_image_media": {
        "alt_text": "Sonoran Reserve leasing office reception desk with yellow chairs and modern lighting.",
        "public_id": "019d02cc-840d-75cf-9253-1b13a322822e",
        "storage_key": "property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near 85745",
      "seo_description": "Find 3 bedroom apartments near 85745 at Sonoran Reserve. Enjoy spacious layouts and premium amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "generator",
      "page_item_url": "4-bedroom-apartments-pima-county",
      "search_query": "4 bedroom apartments pima county",
      "category": "Floorplan",
      "h1_title": "4 Bedroom Apartments in Pima County",
      "h2_subtitle": "Find spacious 4 bedroom apartments in Pima County. Sonoran Reserve offers modern living with premier amenities for families and groups.",
      "page_copy": "Located in the heart of Pima County, Sonoran Reserve provides expansive 4 bedroom apartments perfect for large families or those seeking extra room to breathe. Our floor plans are designed to maximize comfort and living space, with modern finishes and thoughtful details that cater to the needs of both families and groups.\n\nThe lifestyle at Sonoran Reserve extends beyond your apartment walls. Indulge in our resort-style amenities, including a sparkling pool for relaxation, a fitness center equipped with the latest gear, and a clubhouse perfect for social gatherings. Plus, with easy access to local attractions in Pima County, our community is perfectly situated for both convenience and leisure. Experience a superior standard of living with our spacious 4 bedroom options at Sonoran Reserve.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
      "featured_image_media": {
        "alt_text": "Sonoran Reserve leasing office reception desk with yellow chairs and modern lighting.",
        "public_id": "019d02cc-840d-75cf-9253-1b13a322822e",
        "storage_key": "property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "4 Bedroom Apartments in Pima County",
      "seo_description": "Explore 4 bedroom apartments in Pima County at Sonoran Reserve. Enjoy modern amenities and spacious layouts perfect for families and groups.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-arizona-tucson",
      "search_query": "apartments near university of arizona tucson",
      "category": "School",
      "h1_title": "Apartments Near University of Arizona",
      "h2_subtitle": "Discover apartments near University of Arizona, Tucson. Sonoran Reserve offers easy access and vibrant community living.",
      "page_copy": "Sonoran Reserve is the ideal choice for those seeking apartments near the University of Arizona, Tucson. Our community combines convenience with comfort, providing an excellent location just moments away from campus, making it perfect for students, faculty, and staff alike. Whether you prefer a one-bedroom retreat or a spacious four-bedroom home, we offer a variety of floor plans to suit your lifestyle.\n\nEnjoy the perfect blend of academics and leisure with access to our premium amenities, such as a resort-style pool that offers a refreshing escape and a fitness center equipped to support all your exercise needs. Conveniently located near the University of Arizona, Tucson, Sonoran Reserve places you in the heart of a vibrant community while providing all the comforts of home. Experience the best in apartment living today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
      "featured_image_media": {
        "alt_text": "Sonoran Reserve leasing office reception desk with yellow chairs and modern lighting.",
        "public_id": "019d02cc-840d-75cf-9253-1b13a322822e",
        "storage_key": "property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Arizona",
      "seo_description": "Find ideal apartments near University of Arizona, Tucson at Sonoran Reserve. Enjoy modern living with excellent amenities just steps from campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "generator",
      "page_item_url": "apartment-rentals-close-to-pima-community-college-west-campus",
      "search_query": "apartment rentals close to pima community college west campus",
      "category": "School",
      "h1_title": "Rentals Near Pima Community College West",
      "h2_subtitle": "Explore apartment rentals close to Pima Community College West Campus. Sonoran Reserve offers both affordability and convenience.",
      "page_copy": "For those searching for apartment rentals close to Pima Community College West Campus, Sonoran Reserve is the perfect solution. Located in a prime area that offers a short commute to the college, our apartment community combines proximity with practical living options ideal for students and faculty members alike. Choose from our diverse selection of one to four-bedroom floor plans, crafted to suit a variety of living arrangements.\n\nAt Sonoran Reserve, the perks extend beyond location. Enjoy resort-like amenities, including a shimmering pool for relaxation, a cutting-edge fitness center to keep you active, and a welcoming clubhouse to socialize and study with fellow residents. All conveniently situated near Pima Community College West Campus, these amenities and our vibrant community environment create a well-rounded college experience. Make Sonoran Reserve your home base and enjoy easy access to educational opportunities and urban convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
      "featured_image_media": {
        "alt_text": "Sonoran Reserve leasing office reception desk with yellow chairs and modern lighting.",
        "public_id": "019d02cc-840d-75cf-9253-1b13a322822e",
        "storage_key": "property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Pima Community College West",
      "seo_description": "Discover apartment rentals close to Pima Community College West Campus at Sonoran Reserve. Enjoy student-friendly amenities and easy commutes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "generator",
      "page_item_url": "apartments-near-pima-community-college-downtown-campus",
      "search_query": "apartments in tuscon az near pima community college downtown campus",
      "category": "School",
      "h1_title": "Apartments in Tucson, AZ Near Pima College",
      "h2_subtitle": "Find modern apartments in Tucson, AZ near Pima Community College Downtown Campus. Sonoran Reserve offers premier living options with easy access.",
      "page_copy": "Sonoran Reserve provides the perfect setting for those seeking apartments in Tucson, AZ near Pima Community College Downtown Campus. Positioned ideally for both students and professionals, our community offers an effortless commute to the heart of downtown Tucson while providing a peaceful retreat from the bustling city life. Choose from our diverse range of floor plans, from cozy one-bedroom units to expansive four-bedroom homes.\n\nLuxurious living extends beyond the home at Sonoran Reserve, featuring top-of-the-line amenities such as a resort-style pool perfect for unwinding on warm Arizona days, and a state-of-the-art fitness center designed to support your health goals. With quick access to downtown attractions and educational opportunities, our apartments offer the perfect balance of work, play, and study in Tucson. Make Sonoran Reserve your home and enjoy the dynamic lifestyle you deserve.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
      "featured_image_media": {
        "alt_text": "Sonoran Reserve leasing office reception desk with yellow chairs and modern lighting.",
        "public_id": "019d02cc-840d-75cf-9253-1b13a322822e",
        "storage_key": "property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments in Tucson, AZ Near Pima College",
      "seo_description": "Discover premier apartments in Tucson, AZ near Pima Community College Downtown. Enjoy modern amenities and convenient living at Sonoran Reserve.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "generator",
      "page_item_url": "apartments-near-health-sciences-innovation-building-pima-county",
      "search_query": "apartments around health sciences innovation building pima county",
      "category": "School",
      "h1_title": "Apartments Around Health Sciences Building",
      "h2_subtitle": "Explore apartments around the Health Sciences Innovation Building in Pima County. Sonoran Reserve offers modern comforts and convenient access.",
      "page_copy": "If you're in search of apartments around the Health Sciences Innovation Building in Pima County, Sonoran Reserve perfectly fits the bill. Our community offers an ideal location for students, professionals, and anyone involved with the Health Sciences Innovation Building. Enjoy easy access alongside the comfort and convenience of our wide range of floor plans, from intimate one-bedroom homes to spacious four-bedroom options.\n\nAt Sonoran Reserve, you can enjoy amenities that enhance your living experience. A sparkling pool provides a tranquil setting for relaxation, while our fitness center supports your wellness journey. With high-speed internet access and a welcoming clubhouse, our community creates an ideal environment for work and leisure. Positioned just a short drive from the Health Sciences Innovation Building, our location supports both professional pursuits and personal relaxation, making Sonoran Reserve the ideal place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
      "featured_image_media": {
        "alt_text": "Sonoran Reserve leasing office reception desk with yellow chairs and modern lighting.",
        "public_id": "019d02cc-840d-75cf-9253-1b13a322822e",
        "storage_key": "property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Around Health Sciences Building",
      "seo_description": "Find ideal apartments near the Health Sciences Innovation Building, Pima County. Enjoy modern amenities and convenience at Sonoran Reserve.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "generator",
      "page_item_url": "apartments-near-banner-university-medical-center-tucson",
      "search_query": "apartments near Banner University Medical Center Tucson",
      "category": "Hospital",
      "h1_title": "Apartments Near Banner Medical Center Tucson",
      "h2_subtitle": "Discover apartments near Banner University Medical Center Tucson. Sonoran Reserve offers convenience and modern amenities for medical professionals.",
      "page_copy": "Sonoran Reserve offers excellent options for those seeking apartments near Banner University Medical Center Tucson. Our well-appointed community is strategically located, making it an ideal choice for medical professionals, students, and staff looking for proximity and comfort. With a variety of floor plans from one-bedroom layouts to expansive four-bedroom residences, you'll find the perfect home to suit your needs.\n\nResiding at Sonoran Reserve means more than just a convenient location. Enjoy a host of resort-style amenities, including a refreshing pool to unwind after a busy day at the hospital, a state-of-the-art fitness center to maintain your health goals, and an inviting clubhouse for relaxation and socializing. With easy access to Banner University Medical Center Tucson, living at Sonoran Reserve ensures a seamless balance between professional commitments and personal time. Choose us as your dwelling place for high-quality living and exceptional convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
      "featured_image_media": {
        "alt_text": "Sonoran Reserve leasing office reception desk with yellow chairs and modern lighting.",
        "public_id": "019d02cc-840d-75cf-9253-1b13a322822e",
        "storage_key": "property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Banner Medical Center Tucson",
      "seo_description": "Explore comfortable living with Sonoran Reserve, offering modern apartments near Banner University Medical Center Tucson. Perfect for medical professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "generator",
      "page_item_url": "apartments-close-to-carondelet-st-marys-hospital-pima-county",
      "search_query": "apartments close to Carondelet St. Mary's Hospital in Pima County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Carondelet St. Mary's Hospital",
      "h2_subtitle": "Explore apartments close to Carondelet St. Mary's Hospital in Pima County. Sonoran Reserve offers convenience with modern features and amenities.",
      "page_copy": "For those searching for apartments close to Carondelet St. Mary's Hospital in Pima County, Sonoran Reserve stands out as a prime choice. Located just a short drive from the hospital, our community is perfectly suited for healthcare workers, students, and anyone who values proximity to essential facilities. We offer a comprehensive range of floor plans, from efficient one-bedroom spaces to expansive four-bedroom homes.\n\nAt Sonoran Reserve, quality living extends beyond your apartment. Our community features a variety of amenities designed to enhance your lifestyle, including a sparkling pool for relaxation, a cutting-edge fitness center to keep you active, and a welcoming clubhouse for gatherings and downtime. High-speed internet access and practical features like storage spaces ensure your daily needs are met. Choosing Sonoran Reserve means enjoying the perfect blend of comfort and convenience near Carondelet St. Mary's Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
      "featured_image_media": {
        "alt_text": "Sonoran Reserve leasing office reception desk with yellow chairs and modern lighting.",
        "public_id": "019d02cc-840d-75cf-9253-1b13a322822e",
        "storage_key": "property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Carondelet St. Mary's Hospital",
      "seo_description": "Discover convenient living at Sonoran Reserve with apartments close to Carondelet St. Mary's Hospital in Pima County. Enjoy modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "generator",
      "page_item_url": "apartments-near-sweetwater-wetlands-park-tucson",
      "search_query": "apartments near Sweetwater Wetlands Park Tucson",
      "category": "Park",
      "h1_title": "Apartments Near Sweetwater Wetlands Park",
      "h2_subtitle": "Discover beautiful apartments near Sweetwater Wetlands Park in Tucson. Sonoran Reserve combines nature with modern living.",
      "page_copy": "For nature enthusiasts seeking apartments near Sweetwater Wetlands Park, Tucson, Sonoran Reserve provides the ideal blend of natural beauty and modern comfort. Situated conveniently close to this serene haven, our community offers a perfect home base for those who enjoy outdoor activities and tranquil landscapes. Choose from a variety of apartment styles, from cozy one-bedroom units to spacious four-bedroom retreats, all designed with comfort and style in mind.\n\nLiving at Sonoran Reserve means having resort-style amenities at your doorstep, with a sparkling pool for those warm Tucson days, a fitness center equipped with the latest machinery, and a welcoming clubhouse perfect for social gatherings. The proximity to Sweetwater Wetlands Park not only offers opportunities for bird watching and peaceful walks but also ensures a peaceful living environment in the midst of nature's splendor. Experience the joy of living near one of Tucson's natural gems while benefiting from the conveniences of modern living at Sonoran Reserve.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
      "featured_image_media": {
        "alt_text": "Sonoran Reserve leasing office reception desk with yellow chairs and modern lighting.",
        "public_id": "019d02cc-840d-75cf-9253-1b13a322822e",
        "storage_key": "property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Sweetwater Wetlands Park Tucson",
      "seo_description": "Find beautiful apartments at Sonoran Reserve, near Sweetwater Wetlands Park in Tucson, featuring modern amenities and a nature-friendly location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "generator",
      "page_item_url": "sonoran-reserve-by-himmel-park-az",
      "search_query": "Sonoran Reserve by Himmel Park AZ",
      "category": "Park",
      "h1_title": "Sonoran Reserve Near Himmel Park, AZ",
      "h2_subtitle": "Experience Sonoran Reserve by Himmel Park, AZ. Our community offers chic living spaces with easy access to the park's serene environment.",
      "page_copy": "Sonoran Reserve invites you to explore a living experience near the captivating Himmel Park, AZ. Enjoy the vibrancy of Tucson while residing in a community that offers both urban convenience and tranquility. Our selection of one to four-bedroom apartments provides flexibility and style, perfect for professionals and families alike craving a peaceful setting close to the natural beauty of Himmel Park.\n\nBeyond the comfort of your apartment, Sonoran Reserve offers a host of amenities designed to enhance your lifestyle. Take a dip in our sparkling pool, stay active in the state-of-the-art fitness center, or relax with friends in our inviting clubhouse. With Himmel Park's picturesque landscapes just a short journey away, you can enjoy refreshing walks, picnics, and community events, making Sonoran Reserve a perfect blend of relaxation and recreation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
      "featured_image_media": {
        "alt_text": "Sonoran Reserve leasing office reception desk with yellow chairs and modern lighting.",
        "public_id": "019d02cc-840d-75cf-9253-1b13a322822e",
        "storage_key": "property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sonoran Reserve by Himmel Park, AZ",
      "seo_description": "Discover stylish living at Sonoran Reserve near Himmel Park, AZ, offering modern amenities and easy access to the park's serene beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "generator",
      "page_item_url": "living-close-to-tumamoc-hill-pima-county",
      "search_query": "living close to Tumamoc Hill Pima County",
      "category": "Park",
      "h1_title": "Living Close to Tumamoc Hill",
      "h2_subtitle": "Experience living close to Tumamoc Hill in Pima County at Sonoran Reserve. Enjoy outdoor adventures and modern comforts.",
      "page_copy": "Residents seeking a lifestyle close to Tumamoc Hill in Pima County will find Sonoran Reserve an exceptional choice. With its proximity to this popular hiking destination, our community attracts outdoor enthusiasts who enjoy the scenic beauty and trails offered by Tumamoc Hill. Choose from our spacious one to four-bedroom apartments, each designed to offer comfort and style tailored to your lifestyle.\n\nAt Sonoran Reserve, the amenities extend your living experience. From taking a leisurely swim in the sparkling pool to working out in our state-of-the-art fitness center, you’ll find everything you need is right at home. The high-speed internet access and comfortable living spaces ensure you stay connected and relaxed. Embrace a dynamic, active lifestyle with the natural trails of Tumamoc Hill nearby, while cherishing the modern comforts that Sonoran Reserve provides.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
      "featured_image_media": {
        "alt_text": "Sonoran Reserve leasing office reception desk with yellow chairs and modern lighting.",
        "public_id": "019d02cc-840d-75cf-9253-1b13a322822e",
        "storage_key": "property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Close to Tumamoc Hill, Pima County",
      "seo_description": "Enjoy outdoor living at Sonoran Reserve, close to Tumamoc Hill in Pima County. Our community combines natural beauty with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166453",
      "source": "generator",
      "page_item_url": "danny-lopez-park-nearby-haven-ridge-apartments",
      "search_query": "Danny Lopez Park nearby Haven Ridge apartments",
      "category": "Park",
      "h1_title": "Nearby Haven Ridge Apartments at Danny Lopez Park",
      "h2_subtitle": "Discover Haven Ridge Apartments near Danny Lopez Park. Perfect for those who love outdoor activities and tranquil living.",
      "page_copy": "For those searching for a vibrant community with easy access to Danny Lopez Park, Haven Ridge Apartments offer the perfect solution. These apartments are placed in an ideal location for those who relish outdoor activities and want a peaceful yet engaging environment. Our community offers a range of floor plans from one to four bedrooms, designed with modern amenities to suit diverse lifestyles.\n\nSituated near Danny Lopez Park, Haven Ridge Apartments provide a unique opportunity to enjoy recreational activities right at your doorstep. Engage with nature on refreshing walks, play sports, or simply relax in the lush green spaces available at the park. Coupled with our own community amenities like a shimmering pool, a cutting-edge fitness center, and a welcoming clubhouse, you’ll find all the comforts of home combined with the benefits of outdoor living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
      "featured_image_media": {
        "alt_text": "Sonoran Reserve leasing office reception desk with yellow chairs and modern lighting.",
        "public_id": "019d02cc-840d-75cf-9253-1b13a322822e",
        "storage_key": "property/6767906449166453/019d02cc-840d-75cf-9253-1b13a322822e.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Haven Ridge Apts by Danny Lopez Park",
      "seo_description": "Explore Haven Ridge Apartments near Danny Lopez Park, offering modern living with access to outdoor activities and serene landscapes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5325"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18104425529"
    },
    {
      "ID": "custom_lea_chatbot",
      "type": "STRING",
      "value": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=a9828f95d626e863e8f7ef232d0c89951d725cf37b81dbdfb07546d61ace37443a3a70f74d853e42492e0c9e0529ed6a\"></script>"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KR54L2S8"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Milburn"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Milburn Homestead"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "232SRV"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40241387851"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "BR573712000"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Sonoran Reserve/scheduletourwidget/C3oHKG7ifvVOpImi0K/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InBmaEgzRFBjcytaendyZ29PVW9GeGc9PSIsInZhbHVlIjoiV250K3hhRlZ2UjA4MUpIOElJd1dMZz09IiwibWFjIjoiM2RmMWNmYmM0Mjk2ZjZlNzJhMDg5MGJkNTZhZWYyMDMxZDYxNjQyNWEwMmFmNTIxZTc5OTlkNzhkNjc2ZDBiMSJ9"
    }
  ],
  "custom_qb_id": "5325",
  "custom_repli_id": "18104425529",
  "custom_lea_chatbot": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=a9828f95d626e863e8f7ef232d0c89951d725cf37b81dbdfb07546d61ace37443a3a70f74d853e42492e0c9e0529ed6a\"></script>",
  "custom_google_gtm_id": "GTM-KR54L2S8",
  "custom_rollout_phase": "Milburn",
  "custom_vibesites_theme": "Milburn Homestead",
  "custom_aim_property_code": "232SRV",
  "custom_hubspot_company_id": "40241387851",
  "custom_broker_license_number": "BR573712000",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Sonoran Reserve/scheduletourwidget/C3oHKG7ifvVOpImi0K/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InBmaEgzRFBjcytaendyZ29PVW9GeGc9PSIsInZhbHVlIjoiV250K3hhRlZ2UjA4MUpIOElJd1dMZz09IiwibWFjIjoiM2RmMWNmYmM0Mjk2ZjZlNzJhMDg5MGJkNTZhZWYyMDMxZDYxNjQyNWEwMmFmNTIxZTc5OTlkNzhkNjc2ZDBiMSJ9",
  "custom_audioeye_site_id": "b44bb664-005b-4400-9e5a-f4b26c2cd2b4",
  "custom_audioeye_site_hash": "ff513f9fbac198993cad9f26c3cf6c6b"
};

export const generatedAt = '2026-08-24T16:59:15.033Z';
